export const subtitles = {
    "1": {
        "startTime": 14.37,
        "endTime": 19.97,
        "transcript": "Wanigg' ayagyuallemni qasgimi angturrillruunga.",
        "translation": "When I was young, I grew up in the community house."
    },
    "2": {
        "startTime": 19.975,
        "endTime": 25.525,
        "transcript": "Tua-i-llu icigg' aatama caniani qavarturatullruunga qasgimi",
        "translation": "Then, you know, I would always sleep by my father in the community house"
    },
    "3": {
        "startTime": 25.525,
        "endTime": 29.62,
        "transcript": "Yugugarni waten iciw', you know qasgiq, nallunritan.",
        "translation": "Among many people like this, you know, the community house, you know it."
    },
    "4": {
        "startTime": 29.62,
        "endTime": 36.37,
        "transcript": "Cuukvagtulirmiut pingqellruut, tua-i qasgingqellruut ingluktulput.",
        "translation": "Cuukvagtulirmiut also had a community house, our competitors."
    },
    "5": {
        "startTime": 36.72,
        "endTime": 39.44,
        "transcript": "Atama caniani.",
        "translation": "By my father."
    },
    "6": {
        "startTime": 39.895,
        "endTime": 48.365,
        "transcript": "Tua-i-llu quliini qavayarallret waten ingleqtullruut two feet qasgit",
        "translation": "Then above there, the community houses had sleeping areas, bedding, two feet"
    },
    "7": {
        "startTime": 48.365,
        "endTime": 50.665,
        "transcript": "Two feet muragnek.",
        "translation": "Two feet of wood."
    },
    "8": {
        "startTime": 52.43,
        "endTime": 58.57,
        "transcript": "Tua-i-llu pinarianga cali atrarlua kanavet natermun, floor",
        "translation": "Then when it was time, I'd go down to the nateq, the floor"
    },
    "9": {
        "startTime": 58.575,
        "endTime": 61.815,
        "transcript": "Nacitnun, iciw' floor-amun.",
        "translation": "The floor planks, you know, to the floor."
    },
    "10": {
        "startTime": 61.815,
        "endTime": 65.225,
        "transcript": "Qavaraqlua tua-i camek pivkenata.",
        "translation": "I would sleep, and we wouldn't mind."
    },
    "11": {
        "startTime": 65.225,
        "endTime": 74.275,
        "transcript": "Aliumaksuarnek makucinek waten, wall'u-q' imkunek Yupiartarnek aliimatpianek akicirluta qavaraqluta.",
        "translation": "These kinds of small gloves, or, we would use those traditional Yup'ik gloves as headrests and sleep."
    },
    "12": {
        "startTime": 74.275,
        "endTime": 79.765,
        "transcript": "Right, cavkenani wangkuta wani ak'a tamaani, you know?",
        "translation": "Right, it was nothing to us a long time ago, you know?"
    },
    "13": {
        "startTime": 82.875,
        "endTime": 85.665,
        "transcript": "Tua-i tuaten yuullruukut.",
        "translation": "That's how we lived."
    },
    "14": {
        "startTime": 86.055,
        "endTime": 91.585,
        "transcript": "Wii apa'urluma anglicallruanga.",
        "translation": "My grandfather raised me."
    },
    "15": {
        "startTime": 91.585,
        "endTime": 93.14,
        "transcript": "Anglicarpek'nii.",
        "translation": "He didn't raise me."
    },
    "16": {
        "startTime": 93.14,
        "endTime": 97.17,
        "transcript": "Waten unuakumi qavarcecuitellruanga.",
        "translation": "He wouldn't let me sleep in the morning like this."
    },
    "17": {
        "startTime": 97.61,
        "endTime": 103.21,
        "transcript": "Cunaw' tang elluarrlua yuusqellua pillrullinikiinga.",
        "translation": "Apparently, he did that so that I would live well."
    },
    "18": {
        "startTime": 103.215,
        "endTime": 109.435,
        "transcript": "Waten-llu qava'arqama waten, waten tupagyarturnauraanga waten ukugnegun pilua.",
        "translation": "And when I slept like this, he would come wake me up [shaking] these."
    },
    "19": {
        "startTime": 111.29,
        "endTime": 119.18,
        "transcript": "Tua-i-ll' cailkamek apa'urluma-llam pikanga, \"Ani patagmek qagaavet ellamun\"",
        "translation": "Then when my grandfather said from the floor, \"Quickly go outside\""
    },
    "20": {
        "startTime": 119.18,
        "endTime": 121.72,
        "transcript": "Ellami-gguq atam assiriqerrniartua.",
        "translation": "He said I'd feel better outside."
    },
    "21": {
        "startTime": 121.725,
        "endTime": 127.8,
        "transcript": "Ellamun ankuma assiriqerrluni ayuquciqa, cegg'arlua, qavarniyugnairrlua.",
        "translation": "When I went out, I'd feel better, awake, and no longer sleepy at all."
    },
    "22": {
        "startTime": 127.8,
        "endTime": 134.86,
        "transcript": "Man'a-ll' tekilluku maa-i qavayunii unuakumi wani kesianek [?].",
        "translation": "And to this day, I never sleep in the morning [?]."
    },
    "23": {
        "startTime": 134.865,
        "endTime": 138.025,
        "transcript": "Kass'atun qanraqlua pikuma.",
        "translation": "I should say some things in English."
    },
    "24": {
        "startTime": 166.07,
        "endTime": 170.49,
        "transcript": "These days, I don't hear anyone instructing anymore.",
        "translation": "These days, I don't hear anyone instructing anymore."
    },
    "25": {
        "startTime": 170.495,
        "endTime": 178.705,
        "transcript": "Wangkuta-wa tua-i ciunerurtellriani nipngami, qavalriatun ellirtuq man'a qanruyutvut.",
        "translation": "Since it's gone out like a light in us who've become elders, it's like our traditional wisdom is sleeping."
    },
    "26": {
        "startTime": 179.255,
        "endTime": 189.255,
        "transcript": "Man'a qanruyutvut, nunavut arcaqerluku meq-llu kencikesqumaluku pitullruitkut.",
        "translation": "In our traditional wisdom, they would especially tell us to revere our land and the water."
    },
    "27": {
        "startTime": 190.89,
        "endTime": 192.91,
        "transcript": "Kencikluku.",
        "translation": "Revere it."
    },
    "28": {
        "startTime": 192.915,
        "endTime": 201.155,
        "transcript": "Wagg'uq-am waniw' tua-i ayuqucirtuastemta ayuqucia:",
        "translation": "In other words, this is what our instructors were like:"
    },
    "29": {
        "startTime": 201.83,
        "endTime": 204.94,
        "transcript": "Wangkuta-gguq-am qantamcetun pitarrluku.",
        "translation": "[Revere nature] as much as our own bowls."
    },
    "30": {
        "startTime": 204.94,
        "endTime": 209.72,
        "transcript": "Mat'um nalliini tuaten ellinrituq. Allaurtuq.",
        "translation": "These days, it's not like that. It's become different."
    },
    "31": {
        "startTime": 211.085,
        "endTime": 214.675,
        "transcript": "Cauga tauna wani \"qantamcetun pitarrluku?\"",
        "translation": "What does that mean, \"as much as our own bowls?\""
    },
    "32": {
        "startTime": 214.675,
        "endTime": 217.265,
        "transcript": "Waten tua-i taringela'arqa:",
        "translation": "This is how I understand it:"
    },
    "33": {
        "startTime": 218.075,
        "endTime": 228.51,
        "transcript": "Qantaput man'a wangkuta ner'aqamta, tamaani-w' ciuqvani qantangqetulliniami yuk atauciq, qantani tua- murilkelluku pillilria.",
        "translation": "Our bowls when we eat, at least, since a person had one bowl in the past back then, (s)he watched their bowl carefully."
    },
    "34": {
        "startTime": 228.51,
        "endTime": 231.83,
        "transcript": "Kenekluku tua-i, kencikluku.",
        "translation": "They treated it with love, reverence."
    },
    "35": {
        "startTime": 232.835,
        "endTime": 237.285,
        "transcript": "Cuqyutekluku-am wiinga tamana pilaryukaqa",
        "translation": "I think that is a metaphor"
    },
    "36": {
        "startTime": 237.955,
        "endTime": 243.595,
        "transcript": "Nunavut meq-llu kencikesqelluku wangkuta qantamcetun pitarrluku.",
        "translation": "That we should revere our land and water as much as our own bowls."
    },
    "37": {
        "startTime": 243.86,
        "endTime": 248.84,
        "transcript": "Au͡gkut yullret tua-i man'a ilii qanruyutiit.",
        "translation": "This is part of the traditional wisdom of the people long ago."
    },
    "38": {
        "startTime": 250.205,
        "endTime": 256.565,
        "transcript": "Cali-llu qantullrulriit-am",
        "translation": "They also used to say"
    },
    "39": {
        "startTime": 262.18,
        "endTime": 270.39,
        "transcript": "Tan'gaurluq waten nasaurlurmek aipirtuasqevkenaku arnamek tegupailgan.",
        "translation": "They said that a boy should not be with a girl before he takes a women [as a wife]."
    },
    "40": {
        "startTime": 271.5,
        "endTime": 275.73,
        "transcript": "Wangkuta, wangkuta mat'um nalliini navguagukut wangkutnek.",
        "translation": "We are destroying ourselves these days."
    },
    "41": {
        "startTime": 275.73,
        "endTime": 280.53,
        "transcript": "Unguvarput una navgualliniarput, temvut-llu una navgualliniarput.",
        "translation": "We are destroying our lives, and we are destroying our bodies."
    },
    "42": {
        "startTime": 280.535,
        "endTime": 286.165,
        "transcript": "Mat'ukun-llu, wiinga aturyulallruaqa cakneq man'a taangaq.",
        "translation": "And with this, I also used to heavily abuse alcohol."
    },
    "43": {
        "startTime": 287.205,
        "endTime": 291.355,
        "transcript": "Tamaa-i tamana uum tememta navguateklinia.",
        "translation": "That is what destroys our bodies."
    },
    "44": {
        "startTime": 291.755,
        "endTime": 301.545,
        "transcript": "Cali-llu tua-i-wa yuk cacurlagqami alaitelartuq nunat tamiini",
        "translation": "Also, when a person does something bad, it is known all across the land"
    },
    "45": {
        "startTime": 302.205,
        "endTime": 304.925,
        "transcript": "Tamaani arcaqerluni.",
        "translation": "Especially back then."
    },
    "46": {
        "startTime": 306.5,
        "endTime": 310.62,
        "transcript": "Arcaqerluteng inerciigatellrunricaaqngameng tamaani",
        "translation": "Since they weren't so terribly mischievous back then"
    },
    "47": {
        "startTime": 310.625,
        "endTime": 314.735,
        "transcript": "Iliini piqalira mistutullruuq.",
        "translation": "The occassional one who [misbehaved] would be conspicuous."
    },
    "48": {
        "startTime": 315.525,
        "endTime": 321.495,
        "transcript": "Mat'um nalliini unuaquaqan ping'e'rmi qaillun wangkuta ellirtukut",
        "translation": "These days, though they [misbehave] every day, we've become different"
    },
    "49": {
        "startTime": 321.495,
        "endTime": 325.03,
        "transcript": "Wangkuta-ll' tua-i tegganerni camek qanyuirucamta.",
        "translation": "Because we elders don't say anything anymore."
    },
    "50": {
        "startTime": 325.03,
        "endTime": 334.68,
        "transcript": "Avani ciuqvaarni qanqautetullruit amllermek pinrilnge'rmegteki tua-i anglanitekevkenateng.",
        "translation": "Back then, they would instruct them, even if it wasn't a lot, not taking things lightly."
    },
    "51": {
        "startTime": 359.35,
        "endTime": 369.88,
        "transcript": "Kinkut imkut niicugnilriit-wa asguranaitkacagarnek, piciulrianek qalangssagtua.",
        "translation": "To anyone listening, I am speaking of things that are not unbelievable, that are true."
    },
    "52": {
        "startTime": 369.88,
        "endTime": 381.41,
        "transcript": "Iluramni qakemkuni, waniw' tua-i atengqertuq Kunuin, Qinarmiu, Tuntutuliaraam nunaliaqestii.",
        "translation": "To my cousins out there, my name is Kunuin from Qinaq, who has moved as Tuntutuliar."
    },
    "53": {
        "startTime": 381.41,
        "endTime": 385.76,
        "transcript": "Tuntutuliar 1945 nunaliaqellrukeka.",
        "translation": "I moved to Tuntutuliar in 1945."
    },
    "54": {
        "startTime": 385.76,
        "endTime": 392.33,
        "transcript": "Tua-i unaumek waniwa quyatekaqa KYUK-t kelgatnga.",
        "translation": "Today, I am thankful that KYUK invited me."
    },
    "55": {
        "startTime": 392.33,
        "endTime": 400.36,
        "transcript": "Elluatussiyaanricaaqua. Pelluusqelluku waniw' arenqialluguteka quyatekluku atuqatartua.",
        "translation": "I'm not completely well. I am going to sing a song of gratitude so that my problem may pass."
    },
    "56": {
        "startTime": 400.36,
        "endTime": 406.32,
        "transcript": "Nutaan akertem tanqiani cali elluarrluci ilakluci tamamta pekcuumirluta.",
        "translation": "Let us desire to walk well together in the light of the sun."
    },
    "57": {
        "startTime": 406.815,
        "endTime": 412.51,
        "transcript": "Quyaukut tagi-yara-ya",
        "translation": "We're thankful tagi-yara-ya"
    },
    "58": {
        "startTime": 412.51,
        "endTime": 417.92,
        "transcript": "Kanangqaukut tagi-yara-ya",
        "translation": "We're bowing yagi-yara-ya"
    },
    "59": {
        "startTime": 417.92,
        "endTime": 423.0,
        "transcript": "Ii-rri-rri-yarrai",
        "translation": "Ii-rri-rri-yarrai"
    },
    "60": {
        "startTime": 423.005,
        "endTime": 427.46,
        "transcript": "Elingranaqvaa agya-rrai",
        "translation": "What a cause for gratitude agya-rrai"
    },
    "61": {
        "startTime": 427.46,
        "endTime": 433.01,
        "transcript": "Quyaukut tagi-yara-ya",
        "translation": "We're thankful tagi-yara-ya"
    },
    "62": {
        "startTime": 433.01,
        "endTime": 438.23,
        "transcript": "Kanangqaukut tagi-yara-ya",
        "translation": "We're bowing tagi-yara-ya"
    },
    "63": {
        "startTime": 438.235,
        "endTime": 443.21,
        "transcript": "Ii-rri-rri-yarrai",
        "translation": "Ii-rri-rri-yarrai"
    },
    "64": {
        "startTime": 443.21,
        "endTime": 448.44,
        "transcript": "Elingranaqvaa agya-rrai uu!",
        "translation": "What a cause for gratitude agya-rrai uu!"
    },
    "65": {
        "startTime": 448.44,
        "endTime": 451.53,
        "transcript": "Tua-i-wa tua-i.",
        "translation": "There you have it."
    },
    "66": {
        "startTime": 451.87,
        "endTime": 453.43,
        "transcript": "Tua-llu?",
        "translation": "How was that?"
    },
    "67": {
        "startTime": 479.805,
        "endTime": 482.585,
        "transcript": "Qinarmiuni ellangellruunga.",
        "translation": "My earliest memories are in Qinarmiut."
    },
    "68": {
        "startTime": 483.23,
        "endTime": 493.07,
        "transcript": "Ellanglua tua-i ellangellemni cataitellruuq Qinaq, mat'umek-ll' Qaneryaramek pitaunani.",
        "translation": "In my earliest memories growing up, there was nothing [Wester] in Qinaq, and there was no Bible."
    },
    "69": {
        "startTime": 493.345,
        "endTime": 497.105,
        "transcript": "Agayumalriartaunani.",
        "translation": "There were no Christians."
    },
    "70": {
        "startTime": 497.29,
        "endTime": 506.4,
        "transcript": "Tua-i ellangeqarraallruunga waten kinguqlimnun tuqulriamun tungemnun.",
        "translation": "My earliest memories are when my next younger sibling died."
    },
    "71": {
        "startTime": 506.4,
        "endTime": 509.16,
        "transcript": "Tua-i tuaken ayaglua ellanglua.",
        "translation": "I've had consistent long-term memories since then."
    },
    "72": {
        "startTime": 509.165,
        "endTime": 513.095,
        "transcript": "Yuut tua-i nallunrirluki Qinarmi.",
        "translation": "I got to know the people in Qinaq."
    },
    "73": {
        "startTime": 513.625,
        "endTime": 520.545,
        "transcript": "Tua-i tuaken ayaglua ellanglua yuut murilkelluki. Qinarmiungulua tua-i.",
        "translation": "I've had consistent memories since then, observing the people. I was from Qinaq."
    },
    "74": {
        "startTime": 522.54,
        "endTime": 529.49,
        "transcript": "Tua-i-llu atam pinariama",
        "translation": "Then, you see, when I became capable"
    },
    "75": {
        "startTime": 529.71,
        "endTime": 539.79,
        "transcript": "Kass'at-llu enurnarluteng, ataucirrarmek tau͡gaam Kass'artarluteng wagg'uq uumek Klondike Johnson, Yugtun piaqluku Parumek.",
        "translation": "There were scarcely any Caucasians, but they had one resident Caucasian whom they called Klondoke Johnson, whom they called Paru in Yup'ik."
    },
    "76": {
        "startTime": 540.145,
        "endTime": 544.285,
        "transcript": "Irniari-wa cetaman tan'gaurluullgutekluki tua-i.",
        "translation": "His four children were our fellow boys."
    },
    "77": {
        "startTime": 544.37,
        "endTime": 547.87,
        "transcript": "Malruk tayim' unguvauk, nuu pingayun.",
        "translation": "Two are still alive, no, three."
    },
    "78": {
        "startTime": 549.355,
        "endTime": 555.87,
        "transcript": "Alikaqa tau͡gaam tauna Paru. Kass'at alikellruaput, carayakluki tua-i.",
        "translation": "But I was scared of Paru. We were scared of Caucasians; they were strange people to us."
    },
    "79": {
        "startTime": 555.87,
        "endTime": 560.07,
        "transcript": "Tangrraqamta, \"Aullu tarrarrngaitua.\" Tua-i alingnaqluteng.",
        "translation": "When we saw them, \"Oh my, I won't walk around.\" They were scary."
    },
    "80": {
        "startTime": 560.075,
        "endTime": 566.595,
        "transcript": "Qinarmiut tua-i taukut yuuluteng, elitnaurviinateng-llu.",
        "translation": "The people of Qinaq lived there, and they didn't have a school."
    },
    "81": {
        "startTime": 566.96,
        "endTime": 575.0,
        "transcript": "Angliriama-llu qasgimun cali itraqama, qasgiaqama",
        "translation": "And when I grew up and went in the community house, when I was at the community house"
    },
    "82": {
        "startTime": 577.045,
        "endTime": 588.22,
        "transcript": "Tauna cunaw' aiparkama, ug'um aiparkama apa'urlua Akagtaq tua-i alikluku.",
        "translation": "I was scared of Akagtaq, the grandfather of the one whom I'd apparently marry, the one whom I'd apparently marry downriver."
    },
    "83": {
        "startTime": 588.22,
        "endTime": 594.12,
        "transcript": "Maurlurlumnek cali taumek friend-angqelliniami itrumaaqami",
        "translation": "When he was in there, since my grandmother was his friend"
    },
    "84": {
        "startTime": 595.285,
        "endTime": 605.94,
        "transcript": "Taum maurlurluma egyaqsuani-llu tua-i alikluku cali ilumun yugnek nertuyukluku.",
        "translation": "Since my grandmother [?joked about] him, I was scared of him thinking that he really used to eat people."
    },
    "85": {
        "startTime": 605.94,
        "endTime": 609.05,
        "transcript": "Cunaw' tua-i tutgarqelliniamia.",
        "translation": "Apparently, it was because I was her grandchild."
    },
    "86": {
        "startTime": 609.42,
        "endTime": 616.53,
        "transcript": "Tua-i ukvekpiarluku, nevukun-llu ciutengqerrniluni.",
        "translation": "I really believed her, and she said he had ears in the soil."
    },
    "87": {
        "startTime": 616.53,
        "endTime": 624.74,
        "transcript": "Amani enemeggni uitaurarqami cauralriit amkut tua-i niirquratuniluki.",
        "translation": "When she was at their house over there, she said she'd hear what was going on over there [in the community house]."
    },
    "88": {
        "startTime": 624.95,
        "endTime": 633.06,
        "transcript": "Tua-i taumek neqamlinguarqerqamku, tua-i cukaqangraan, unuamek maa-i qanlalrianga",
        "translation": "That's why when I remember her, just real quickly, I say today"
    },
    "89": {
        "startTime": 633.06,
        "endTime": 642.52,
        "transcript": "\"Nutaan-tuq imna tayima nevukun ciutengqerrnilalleq yav'anun phone-arcet'larlaku ingrit aciatgun.\"",
        "translation": "\"I wish I could have that one that said she had ears in the soil make a phone call far away under the mountains.\""
    },
    "90": {
        "startTime": 642.525,
        "endTime": 644.895,
        "transcript": "Tua-i tuaten ayuqluteng.",
        "translation": "That's what they were like."
    },
    "91": {
        "startTime": 675.445,
        "endTime": 677.785,
        "transcript": "Qasgilangama",
        "translation": "When I started being at the community house"
    },
    "92": {
        "startTime": 679.64,
        "endTime": 684.39,
        "transcript": "Yuut, qasgilangvailegma tamaani atam",
        "translation": "The people, back before I started going to the community house, you see"
    },
    "93": {
        "startTime": 684.737,
        "endTime": 699.424,
        "transcript": "Waten yuut qetunracuarateng wall'u paniteng yuullermeggni camek unangaqata",
        "translation": "People like this, when their little sons or daughters [first] caught something in their lives"
    },
    "94": {
        "startTime": 699.437,
        "endTime": 704.749,
        "transcript": "Pitqerriirqata boy-acuarateng pitgarluki",
        "translation": "When their little boys made their first catches with arrows"
    },
    "95": {
        "startTime": 704.762,
        "endTime": 714.212,
        "transcript": "Imna tau-i yaquleyagaq kemgirluku, nakaculiluku, ayagcirluku kinertelluku.",
        "translation": "They would remove the flesh from that little bird, hang it to dry threaded through a branch, prop and hang it to dry."
    },
    "96": {
        "startTime": 714.219,
        "endTime": 720.306,
        "transcript": "Tua-i-llu uksuquan kalukarluku.",
        "translation": "Then the next winter, they'd have a feast for him."
    },
    "97": {
        "startTime": 720.319,
        "endTime": 723.381,
        "transcript": "Tuaten tua-i allamiaqan pituluteng.",
        "translation": "They would do that every year."
    },
    "98": {
        "startTime": 723.394,
        "endTime": 729.019,
        "transcript": "Tua-i-ll' wiinga pavani uani neqlillemteńi ak'a",
        "translation": "Then me, in our old fish camp inland, downriver"
    },
    "99": {
        "startTime": 729.025,
        "endTime": 735.838,
        "transcript": "Tagyaram uatiini, pavani-am tarrarrluta pillemteńi tua-i aqvaqulanglua",
        "translation": "Downriver from Tagyaraq, when we wandered inland as I had started running"
    },
    "100": {
        "startTime": 735.85,
        "endTime": 740.95,
        "transcript": "Atam qangqiiq man'a tengvallagyaaqelria igtellria.",
        "translation": "You see, this ptarmigan that had taken off fell."
    },
    "101": {
        "startTime": 740.957,
        "endTime": 744.532,
        "transcript": "As I chased it, it would take off, then fall.",
        "translation": "As I chased it, it would take off, then fall."
    },
    "102": {
        "startTime": 744.538,
        "endTime": 748.063,
        "transcript": "Caqerluku tua-i paallaglua teguluku.",
        "translation": "Eventually, I tripped and took it."
    },
    "103": {
        "startTime": 748.082,
        "endTime": 753.032,
        "transcript": "Tua-i tengssaangraan tengevkaryugnaunaku tuququaluku.",
        "translation": "Though it tried to fly away, I didn't let it and killed it."
    },
    "104": {
        "startTime": 753.039,
        "endTime": 756.626,
        "transcript": "Tayima yua-i qaillun piciinaku.",
        "translation": "I didn't know what became of it."
    },
    "105": {
        "startTime": 756.639,
        "endTime": 766.226,
        "transcript": "Cunaw' tua-i taum maurlurluma nakaculillinikii tuaten tua-i.",
        "translation": "Apparently, my grandmother hung it to try on a tree like that."
    },
    "106": {
        "startTime": 766.239,
        "endTime": 769.714,
        "transcript": "Nalluluku tangeqsaunaku-llu.",
        "translation": "I didn't know and never saw it."
    },
    "107": {
        "startTime": 770.045,
        "endTime": 777.945,
        "transcript": "Tua-i ugna uksuillerput Iingirayuq",
        "translation": "Our winter camp Iingirayuq downriver"
    },
    "108": {
        "startTime": 780.839,
        "endTime": 788.752,
        "transcript": "Family-t pingayun waten taluyarpagcutullruut.",
        "translation": "Three families like this would set big fish traps."
    },
    "109": {
        "startTime": 788.764,
        "endTime": 796.577,
        "transcript": "Whitefish-anek, akakiignek, cingikegglinek neqsutuluteng.",
        "translation": "They would fish for whitefish, broad whitefish, whitefish with pointed heads."
    },
    "110": {
        "startTime": 796.589,
        "endTime": 805.189,
        "transcript": "Tua-i-ll' aatama taum taluyillra cali kan'a nuna acia tua-i neqtuluni tayima tua-i.",
        "translation": "And my father's fish trapping spot under the land down there would have a lot of fish."
    },
    "111": {
        "startTime": 805.208,
        "endTime": 819.183,
        "transcript": "Atam uksuquan Qinarmiut kelelriit, kelellinilriit Iigmun Apruka'armun-llu",
        "translation": "The next winter, you see, Qinarmiut sent invitations to Eek and Apruka'ar"
    },
    "112": {
        "startTime": 819.189,
        "endTime": 822.514,
        "transcript": "Apruka'armiut yungqellratni tuaten pitullruameng.",
        "translation": "Since they did that when Apruka'ar was populated."
    },
    "113": {
        "startTime": 822.533,
        "endTime": 825.583,
        "transcript": "Tua-i allanret tekilluteng.",
        "translation": "The guests arrived."
    },
    "114": {
        "startTime": 825.592,
        "endTime": 834.854,
        "transcript": "Atam akutetullruut qantav'agteggun",
        "translation": "You see, they would make Yup'ik ice cream in huge bowls"
    },
    "115": {
        "startTime": 835.942,
        "endTime": 849.905,
        "transcript": "Akutapianek tunulegnek, uqunek egcetaarluki tangviarrluut kenirluki, ingqiqcaarluki tamaani akutetullermeggni.",
        "translation": "Traditional ice cream with tallow, rendering fat from seal blubber with heat, cutting them up back when they'd make Yup'ik ice cream."
    },
    "116": {
        "startTime": 849.917,
        "endTime": 857.292,
        "transcript": "Tua-i-llu atam pikiitnga, qasgilii-gguq, maligglaki-gguq.",
        "translation": "Then, you see, they told me to go to the community house, that I should go with them."
    },
    "117": {
        "startTime": 857.311,
        "endTime": 866.948,
        "transcript": "Maaten anua ikamrak tua-i au͡gkuk atama neqnek tua-i iqukliarrlukek imarlutek.",
        "translation": "I went out to find my father's sled filled end to end with food."
    },
    "118": {
        "startTime": 866.961,
        "endTime": 870.786,
        "transcript": "Una-w' tang miskav'all'er akutamek imarluni.",
        "translation": "This huge serving bowl had Yup'ik ice cream."
    },
    "119": {
        "startTime": 870.792,
        "endTime": 878.392,
        "transcript": "Imna-wa tang una qangqiirtalqa kiak ayagterluni akutami kapuyuterluni kapusngalria.",
        "translation": "You see, the ptarmigan I'd caught last summer had props [on the wings] and was staked into the ice cream."
    },
    "120": {
        "startTime": 878.411,
        "endTime": 883.249,
        "transcript": "Tua-i kalukallinikiinga taum aatama.",
        "translation": "Apparently, my father held a feast for me."
    },
    "121": {
        "startTime": 883.262,
        "endTime": 889.262,
        "transcript": "Qasginritua. Arenqiatuq taumek imumek yugtutulimek alingua.",
        "translation": "I didn't go to the community house. I was distressed, scared of that cannibal."
    },
    "122": {
        "startTime": 889.269,
        "endTime": 896.081,
        "transcript": "Maligtenritaqa alikataqa tauna unguviin tamaani.",
        "translation": "I didn't go with him because the one whom I was afraid of was alive back then."
    },
    "123": {
        "startTime": 896.094,
        "endTime": 898.819,
        "transcript": "Tua-i tuaten pitullruut.",
        "translation": "That's what they used to do."
    },
    "124": {
        "startTime": 924.675,
        "endTime": 927.825,
        "transcript": "Qasgimi qavalangelriakut.",
        "translation": "We started sleeping in the community house."
    },
    "125": {
        "startTime": 927.832,
        "endTime": 933.919,
        "transcript": "Qasgi tua-i imna qasegpall'er qaillun tayima angtaa.",
        "translation": "That big community house, I'm not sure how big it was."
    },
    "126": {
        "startTime": 933.932,
        "endTime": 943.919,
        "transcript": "Tua-i ayagyuanek ciulirnemteńek-llu, inartaqata piviitnaurtuq.",
        "translation": "Then the young people and our elders lay down for bed, there'd be no room."
    },
    "127": {
        "startTime": 943.932,
        "endTime": 957.319,
        "transcript": "Kinguqvaarkun tua-i itellriani, iliini uani tua-i amiigem, acikaitaqama amiigem aciani ciuqerrani qavalartua cani'irrlua.",
        "translation": "When going in late, sometimes when I had no bedding, I would lay on my below the front of the door and sleep."
    },
    "128": {
        "startTime": 957.332,
        "endTime": 960.207,
        "transcript": "Tuaten tua-i.",
        "translation": "Like that."
    },
    "129": {
        "startTime": 960.213,
        "endTime": 969.638,
        "transcript": "Tua-i tau͡gken unuakumi iliini qanerturalriamun tupagnaurtua pak'mumun.",
        "translation": "Some mornings, however, I would wake up to someone instructing up there."
    },
    "130": {
        "startTime": 969.657,
        "endTime": 980.894,
        "transcript": "Ak'a tua-i angukara'urluut iliit qanerturangellinilria ayuqucirtuutmek, qanruyutmek, yuum yuullerkaanek",
        "translation": "One of the old men woudl already be speaking about instructions, traditional wisdom, how a person should live"
    },
    "131": {
        "startTime": 980.907,
        "endTime": 990.269,
        "transcript": "Tan'gaurluum yuullerkaanek, uk'umek agiirtellriamek atu'urakemek, piciulriamek.",
        "translation": "How a boy shoudl live, what is in store for the future, what is true."
    },
    "132": {
        "startTime": 990.282,
        "endTime": 1000.257,
        "transcript": "Tua-i pekqullagavkenata tua-i maktaqamta tua-i maktaqluta niicugniurluku taun' qanerturalria.",
        "translation": "When we got up, we wouldn't make sudden movements getting up, and listen to that one giving instruction."
    },
    "133": {
        "startTime": 1000.263,
        "endTime": 1002.913,
        "transcript": "Tupaqluta piyuunata.",
        "translation": "They wouldn't force us awake."
    },
    "134": {
        "startTime": 1003.62,
        "endTime": 1007.12,
        "transcript": "Tuaten tua-i unuakut tamaita.",
        "translation": "That happened every morning."
    },
    "135": {
        "startTime": 1007.127,
        "endTime": 1014.452,
        "transcript": "Tuamtellu erenrani waten maqillmeng qamanrani, maqirpatuameng-llu",
        "translation": "Then during the day like this, when their fire bath died down because they'd have blazing fire baths"
    },
    "136": {
        "startTime": 1014.471,
        "endTime": 1023.058,
        "transcript": "Qanerturnaurtut yuullerkamek, uk'umek agiirtellriamek",
        "translation": "They would give instruction about life, the encroaching future"
    },
    "137": {
        "startTime": 1023.071,
        "endTime": 1030.633,
        "transcript": "Tan'gaurluq arnamun elliqan, aren cayugnailngukut-wa.",
        "translation": "When a boy is [married to] a woman, oh my, and it was a long way off for us."
    },
    "138": {
        "startTime": 1030.646,
        "endTime": 1034.646,
        "transcript": "Pellaayairturluta cunaw'.",
        "translation": "Apparently, they gave us a guide so we wouldn't be lost."
    },
    "139": {
        "startTime": 1059.19,
        "endTime": 1066.24,
        "transcript": "Qalangssalartut, tamaani-gguq ciungani tamatum",
        "translation": "They tell stories about how before that"
    },
    "140": {
        "startTime": 1066.259,
        "endTime": 1075.659,
        "transcript": "Wangkuta yuurpailemta, tamakut-ll' angukara'urluut ayagyuarluki nutaan ayuqucirtuun pinirluku atullruat.",
        "translation": "Before we were born, when those old men were boys, they would strongly practice traditional instruction."
    },
    "141": {
        "startTime": 1075.666,
        "endTime": 1082.466,
        "transcript": "Qasgimi, ayuqucirturiqata'arqameng-gguq qasgimi",
        "translation": "They said that when they were going to give instruction in the community house"
    },
    "142": {
        "startTime": 1082.485,
        "endTime": 1086.61,
        "transcript": "Ugna amiik imumek tua-i cigyagmek.",
        "translation": "They would [block] the door with a piece of split spruce."
    },
    "143": {
        "startTime": 1086.616,
        "endTime": 1088.966,
        "transcript": "Cigyak-qaa nallunritan?",
        "translation": "Do you know what cigyak is?"
    },
    "144": {
        "startTime": 1089.448,
        "endTime": 1092.235,
        "transcript": "Iciw' taluyat imkut muriit?",
        "translation": "You know the wood to make fish traps?"
    },
    "145": {
        "startTime": 1092.248,
        "endTime": 1095.648,
        "transcript": "Nauwa? Man'a-ggen pitangqellruuq.",
        "translation": "Where is it? Wasn't there one here?"
    },
    "146": {
        "startTime": 1095.655,
        "endTime": 1100.655,
        "transcript": "Taluyanek, cigyangqelalriit waten iqtutauralrianek.",
        "translation": "Fish traps, they have split spruce that are this wide."
    },
    "147": {
        "startTime": 1100.674,
        "endTime": 1105.837,
        "transcript": "Cani'irrvikaqaat qeratmun.",
        "translation": "They put it on its side crosswise [from the door]."
    },
    "148": {
        "startTime": 1105.849,
        "endTime": 1108.762,
        "transcript": "Nutaan-llu qanruyutmek qalartut.",
        "translation": "And only then would they speak of traditional wisdom."
    },
    "149": {
        "startTime": 1108.774,
        "endTime": 1120.274,
        "transcript": "Tua-lli-wa-gguq tua-i yuut ayuqenritliniameng waten, tan'gaurluut ayuqenritliniameng",
        "translation": "Then they said that because people are different like this, because boys are different"
    },
    "150": {
        "startTime": 1120.281,
        "endTime": 1130.368,
        "transcript": "Ilii-gguq tan'gaurluum anqertaquq qasgimek, imna tamana tapeqluku asemlluku.",
        "translation": "They said that one of the boys would go out of the community house, even breaking that [split spruce]."
    },
    "151": {
        "startTime": 1130.606,
        "endTime": 1137.081,
        "transcript": "Wangliungeqatartut-am, \"Aren arivanrilkii-w' qaneryaram.\"",
        "translation": "They'd start speaking about him, \"Oh my, the traditional wisdom doesn't call him.\""
    },
    "152": {
        "startTime": 1137.1,
        "endTime": 1145.962,
        "transcript": "Tua-i-gguq yuum ik'ikra, yuum ik'ikra tua-i tuaten pilalria, pitulliniaqellria.",
        "translation": "They said that a person who acts improperly does that."
    },
    "153": {
        "startTime": 1170.2,
        "endTime": 1184.913,
        "transcript": "Tuamtellu qakmani arnat cali allakarmeng eneni arnassagallraat imkut eliperneret ayuqucirtuaguratullruit",
        "translation": "Then the women separately out there in the houses, the [?elderly/knowledgeable] old women would would instruct them"
    },
    "154": {
        "startTime": 1185.375,
        "endTime": 1192.438,
        "transcript": "Nasaurluq uingekan, tuaten uinganek aulukillerkaa.",
        "translation": "When a girl takes a husband, how she should take care of her husband."
    },
    "155": {
        "startTime": 1192.45,
        "endTime": 1207.475,
        "transcript": "Tua-lli waten anguanka tuani tua-i uksuillerni ena amiik uaken caniqerrilitarluni canegnek, naqugtarnek tupigluki iterniryailkutnek.",
        "translation": "I caught them [instructing] there in the winter camp, and the door was blocked off with grass, woven grass belts to keep out the draft."
    },
    "156": {
        "startTime": 1208.394,
        "endTime": 1213.306,
        "transcript": "Tua-lli-wa-gguq nevilleraat iliit-am cali",
        "translation": "Then they said that one of the girls as well"
    },
    "157": {
        "startTime": 1213.319,
        "endTime": 1219.757,
        "transcript": "Waten family-nek ena atauciq pingayunek enelgutkurpallutullruut, murilkanka.",
        "translation": "I observed that in one house, three families would mosty live in the same house."
    },
    "158": {
        "startTime": 1219.77,
        "endTime": 1225.195,
        "transcript": "Cetamanek-llu yungqetullrulria family-nek.",
        "translation": "It would also be occupied by four families."
    },
    "159": {
        "startTime": 1225.201,
        "endTime": 1229.164,
        "transcript": "Nevilleraat-gguq iliit anqertaquq.",
        "translation": "They said that one of the girls would go out."
    },
    "160": {
        "startTime": 1229.176,
        "endTime": 1231.926,
        "transcript": "Tua-llam wangliungeqatartut.",
        "translation": "Then they'd speak of her."
    },
    "161": {
        "startTime": 1231.945,
        "endTime": 1247.508,
        "transcript": "Iliin-llu-gguq ingkut imkut caniqerrilitat tapeqluki au͡g'arluki, kapuyukaralget can'get.",
        "translation": "They said that one of them would even take of the grass belt block, the grass that was tacked there."
    },
    "162": {
        "startTime": 1248.37,
        "endTime": 1255.683,
        "transcript": "Tua-i pingayiriaqan-gguq arnassagallram im' taquitaqaa",
        "translation": "They said when she did that for the third time, that old woman would give her her fate"
    },
    "163": {
        "startTime": 1256.283,
        "endTime": 1263.583,
        "transcript": "\"Atak'-gguq au͡gna tua-i pili, caniqaam yukniaraa.\"",
        "translation": "\"Let her do that, so she'll be the person of the threshhold.\""
    },
    "164": {
        "startTime": 1263.59,
        "endTime": 1265.777,
        "transcript": "Caniqaq-qaa nallunritan?",
        "translation": "Do you know what a caniqaq is?"
    },
    "165": {
        "startTime": 1265.79,
        "endTime": 1267.352,
        "transcript": "Nauwa?",
        "translation": "Where is it?"
    },
    "166": {
        "startTime": 1267.365,
        "endTime": 1276.015,
        "transcript": "Amiigem ug'um taqu͡ra caniqauguq. Caniqamek pituat, caniqaq.",
        "translation": "The threshhold of the door out there is a caniqaq. They call it a caniqaq."
    },
    "167": {
        "startTime": 1276.034,
        "endTime": 1281.934,
        "transcript": "Qau͡gna-wa enem egkua kiatkacagaq amiigem ciuqerrani qau͡gna egkuq.",
        "translation": "And the back wall of the house way in there, in front of the door is the egkuq."
    },
    "168": {
        "startTime": 1281.941,
        "endTime": 1288.066,
        "transcript": "Makuk-wa tua-i taquuk tuaten igloo-nek enengqellermeggni.",
        "translation": "This is the threshhold like that when they had sod houses."
    },
    "169": {
        "startTime": 1288.085,
        "endTime": 1290.972,
        "transcript": "\"Caniqaam yukniaraa.\"",
        "translation": "\"She will be the person of the threshhold.\""
    },
    "170": {
        "startTime": 1290.985,
        "endTime": 1300.91,
        "transcript": "Aren kingunertaqaa-gguq, caniqaq-llu yuungnaqelriit atutukiit. \"Natrem yukniaraa.\"",
        "translation": "Oh my, they explained that people who subsist use the threshhold. \"She will be the person of the floor.\""
    },
    "171": {
        "startTime": 1300.916,
        "endTime": 1305.416,
        "transcript": "Cuna-gguq tua-i ciunra, ciunerkaa enik'acagarluku.",
        "translation": "Apparently, she pointed out her exact future."
    },
    "172": {
        "startTime": 1305.435,
        "endTime": 1315.848,
        "transcript": "Aanairulluni, aatairulluni, wantaqluni, wantaqluni qanruyun atunritem ugaani.",
        "translation": "She loses her mother and father, stays here, stays here, because she doesn't heed traditional wisdom."
    },
    "173": {
        "startTime": 1316.16,
        "endTime": 1322.773,
        "transcript": "Tuamtellu qakmani taun' im' qasgimi anqertelalleq",
        "translation": "Then the one who would run out from the community house out there"
    },
    "174": {
        "startTime": 1322.785,
        "endTime": 1328.21,
        "transcript": "Pingayiriaqan-gguq tua-i angullualleraam taquitaqaa",
        "translation": "They said when he does it for a third time, an old man gives him his fate"
    },
    "175": {
        "startTime": 1328.216,
        "endTime": 1336.466,
        "transcript": "\"Atak'-gguq au͡gna tua-i pili, qengaruum iquani keggutekegcianiartuq.\"",
        "translation": "\"Let him do that, so he will show his nice teeth at the end of a snowbank.\""
    },
    "176": {
        "startTime": 1336.485,
        "endTime": 1338.585,
        "transcript": "Taringan-qaa?",
        "translation": "Do you understand it?"
    },
    "177": {
        "startTime": 1338.592,
        "endTime": 1341.117,
        "transcript": "Waten mean-angqertuq:",
        "translation": "This is what it means:"
    },
    "178": {
        "startTime": 1341.136,
        "endTime": 1347.436,
        "transcript": "Iqukvat tamaita ellarrlugiurturatullermeggni, ellarrlugiutullermeggni",
        "translation": "Every [?], when they predicted famines from bad weather"
    },
    "179": {
        "startTime": 1347.443,
        "endTime": 1353.118,
        "transcript": "Tua-i-gguq paluluni mat'umun, qengaruk-qaa nallunritan?",
        "translation": "They said he starves to death here, do you know what a qengaruk is?"
    },
    "180": {
        "startTime": 1353.137,
        "endTime": 1354.874,
        "transcript": "Qanikcaq.",
        "translation": "Snow[bank]."
    },
    "181": {
        "startTime": 1355.037,
        "endTime": 1361.124,
        "transcript": "Yaani iquani, keggutai-wa qercurpak.",
        "translation": "Over at the end, his teeth are very white."
    },
    "182": {
        "startTime": 1361.137,
        "endTime": 1367.487,
        "transcript": "Tua-i-gguq palu'urlurlullinilria. Tua-i keggutekegcialuni-gguq.",
        "translation": "They say the poor guy starves to death. They say he shows his nice teeth."
    },
    "183": {
        "startTime": 1367.494,
        "endTime": 1372.756,
        "transcript": "Tua-i tuaten ayuqellrulliniut.",
        "translation": "Tha'ts what they were like."
    },
    "184": {
        "startTime": 1396.069,
        "endTime": 1399.107,
        "transcript": "Cauyagnek malrugnek eciraqut.",
        "translation": "They put skins on two drums."
    },
    "185": {
        "startTime": 1399.282,
        "endTime": 1406.295,
        "transcript": "Tua-i-llu tan'geraaraan cauyak im' kaugtuarlukek.",
        "translation": "Then when it was getting dark, they'd beat the two drums."
    },
    "186": {
        "startTime": 1406.307,
        "endTime": 1417.57,
        "transcript": "Aug͡na-w' aataka, au͡gna-llu ug'um arnassaga'urluum aatii akiqliqlutek aturpagatullruuk, tau͡gaam yuarutkek elitellrunritanka.",
        "translation": "My father, and the father of the old lady downriver would sing opposite each other, but I didn't learn their songs."
    },
    "187": {
        "startTime": 1417.582,
        "endTime": 1421.345,
        "transcript": "Anglanissiyaaglua pillruaqama elicuitanka.",
        "translation": "I never learned them when I had too much fun."
    },
    "188": {
        "startTime": 1421.357,
        "endTime": 1425.357,
        "transcript": "Canek elisngangqerrssaaqua ilaitnek yuarutet iqupkuitnek.",
        "translation": "I have some incomplete knowledge of some songs."
    },
    "189": {
        "startTime": 1425.364,
        "endTime": 1431.914,
        "transcript": "Tua-i iqukliareskan man'a nallunrilkemnek aturciqua Yugcetun.",
        "translation": "When this is over, I'll sing one I know in Yup'ik."
    },
    "190": {
        "startTime": 1431.933,
        "endTime": 1434.746,
        "transcript": "Aturpaganaurtuk.",
        "translation": "They would sing loudly."
    },
    "191": {
        "startTime": 1435.246,
        "endTime": 1446.683,
        "transcript": "Tua-i-ll' piuraqerluni arnaq iterluni qasgimun imumek neruka'rmek tegumiarluni qantamek.",
        "translation": "Then eventually, a woman would go into the community house holding a ceremonial nerukar bowl [of food]."
    },
    "192": {
        "startTime": 1447.996,
        "endTime": 1456.971,
        "transcript": "Kanavet-llu nacitem qainganun ellirraarluku yurarluni, wagg'uq Ingularluni. Taqngami-llu anluni.",
        "translation": "After she put it down on the floor plank, she would dance what they called an Ingulaq dance. And she went out when she was done."
    },
    "193": {
        "startTime": 1456.977,
        "endTime": 1463.077,
        "transcript": "Muluvkenani tuamtell' arnaq itertuq qantunguarmek tegumiarluni.",
        "translation": "Then before long, a woman would come in with a bowl"
    },
    "194": {
        "startTime": 1463.096,
        "endTime": 1472.684,
        "transcript": "Kiituani tang un'a, nacitat tua-i uuten waten ayalertutatullruut, kenillra qasegpiim.",
        "translation": "Eventually down there, the floor planks would be [?slanted] like this, the fireplace in the big community house."
    },
    "195": {
        "startTime": 1472.697,
        "endTime": 1479.234,
        "transcript": "Nacitet-llu waten muirnaurtuq imkunek qancunguarnek neruka'rnek.",
        "translation": "And the floor planks like this would be filled with small nerukar bowls."
    },
    "196": {
        "startTime": 1479.247,
        "endTime": 1483.409,
        "transcript": "Itenriata-ll' tua-i nutaan cauyak qerrlukek.",
        "translation": "And when they stopped coming in, they put the drums away."
    },
    "197": {
        "startTime": 1483.422,
        "endTime": 1490.547,
        "transcript": "Nerluteng imkut qasgimiut Kass'artauyugnailngurnek",
        "translation": "The people of the community house would eat what was absolutely not Western food"
    },
    "198": {
        "startTime": 1490.553,
        "endTime": 1502.291,
        "transcript": "Qamiquyagarnek tepnek, mak'anek, puyanek, qerpertanek, neqerrluarnek.",
        "translation": "Little fermented fish heads, aged salmon egg ice cream, moss with aged seal oil, whitefish egg ice cream, dried fish."
    },
    "199": {
        "startTime": 1502.304,
        "endTime": 1509.066,
        "transcript": "Wangkuta tan'gaurralle'rni tua-i, \"Puyat assirtut,\" wagg'uq puyat.",
        "translation": "We little boys would say, \"Moss with aged seal oil is good,\" what they call puyat [plural]."
    },
    "200": {
        "startTime": 1509.404,
        "endTime": 1516.892,
        "transcript": "Puyat, yuut puyautaicuitellruut.",
        "translation": "Moss with aged seal oil, people always had puyat."
    },
    "201": {
        "startTime": 1516.905,
        "endTime": 1524.405,
        "transcript": "Urut imkut, urut uqumek mecirluki, au͡gkut urut nunam urui.",
        "translation": "The moss, soak the moss in seal oil, the moss from the land."
    },
    "202": {
        "startTime": 1524.424,
        "endTime": 1526.874,
        "transcript": "Urucararmiunek qanlalriit maani.",
        "translation": "They say Urucararmiut [People of Moss] here."
    },
    "203": {
        "startTime": 1526.881,
        "endTime": 1529.956,
        "transcript": "Urut uqumek mecirluki.",
        "translation": "They soaked moss in seal oil."
    },
    "204": {
        "startTime": 1529.975,
        "endTime": 1537.8,
        "transcript": "Puyaliqataameng-llu tua-i tauna uru meciumakii [?] passiqcaarluku, uqumek kuv'aqluku.",
        "translation": "And when they were going to make puya, they would crush that soaked moss, occassionally pouring in seal oil."
    },
    "205": {
        "startTime": 1537.806,
        "endTime": 1541.106,
        "transcript": "Qatkacagarluni tua-i, eyucuarluni.",
        "translation": "It was very white, and a little congealed."
    },
    "206": {
        "startTime": 1541.113,
        "endTime": 1546.663,
        "transcript": "Tau͡gaam tamakut puyat egmian neryaraugut tua-i cukangnaqluni.",
        "translation": "But those puyat need to be eaten quickly right away."
    },
    "207": {
        "startTime": 1546.682,
        "endTime": 1548.482,
        "transcript": "Wagg'uq tengci[quq].",
        "translation": "They said it'll \"fly away.\""
    },
    "208": {
        "startTime": 1548.489,
        "endTime": 1553.114,
        "transcript": "Uitaskuni tua-i qivia allakarluni, wagg'uq tengluni.",
        "translation": "When left, the berries separate, and they say it \"flies away.\""
    },
    "209": {
        "startTime": 1553.133,
        "endTime": 1555.27,
        "transcript": "Tuaten tua-i.",
        "translation": "Like that."
    },
    "210": {
        "startTime": 1555.283,
        "endTime": 1561.058,
        "transcript": "Assipiat neqet, qamiquyagarnek tua-i tuaten.",
        "translation": "Such good food, even little fermented fish heads."
    },
    "211": {
        "startTime": 1586.039,
        "endTime": 1593.239,
        "transcript": "Uksumi una cali apqiit Itruka'ar.",
        "translation": "In the winter, the one they call Itruka'ar, the \"Inviting-In Feast.\""
    },
    "212": {
        "startTime": 1593.258,
        "endTime": 1599.008,
        "transcript": "Makumiut Itruka'armek acituat yuraryaraq.",
        "translation": "People from here call that dance festival Itruka'ar."
    },
    "213": {
        "startTime": 1599.015,
        "endTime": 1606.977,
        "transcript": "Apqait Itruka'ar tauna angalkurtarnek yuarutetangqertuq, yuarutengqetuut.",
        "translation": "What they call Itruka'ar has shaman songs."
    },
    "214": {
        "startTime": 1606.99,
        "endTime": 1612.29,
        "transcript": "Itrukaraliaqameng angalkullret au͡gkut tangtullruanka.",
        "translation": "When they celebrated Itruka'ar, I used to see those shamans."
    },
    "215": {
        "startTime": 1612.309,
        "endTime": 1622.384,
        "transcript": "Ellaita yuratuit, malrugnek arnaunregnek, ataucirrarmek angutngunercirlutek.",
        "translation": "They dance those songs, with two women, and a single man to accompany them."
    },
    "216": {
        "startTime": 1622.39,
        "endTime": 1629.49,
        "transcript": "Nutaan-llu makut piyulriit elitaameggnek cali angalkuunrilnge'rmeng tua-i.",
        "translation": "And these people who wanted to [would dance songs] they knew even though they weren't shamans."
    },
    "217": {
        "startTime": 1629.509,
        "endTime": 1634.234,
        "transcript": "Unisteka-w' yuarucitullruuq puqignitullruatni.",
        "translation": "My late father would write songs because they said he was skilled."
    },
    "218": {
        "startTime": 1634.24,
        "endTime": 1638.39,
        "transcript": "Itruka'ar una tamatuuguq.",
        "translation": "That's what this Itruka'ar celebration is."
    },
    "219": {
        "startTime": 1638.409,
        "endTime": 1642.597,
        "transcript": "Itruka'armek agayumek acirluku pituluteng.",
        "translation": "They would practice what they called the Itruka'ar celebration."
    },
    "220": {
        "startTime": 1642.61,
        "endTime": 1649.472,
        "transcript": "Una-w' aipaa Kevgiq. Yuraryaraq nutaan.",
        "translation": "This other one, the Messenger Feast. Now that was a dance festival."
    },
    "221": {
        "startTime": 1649.485,
        "endTime": 1655.448,
        "transcript": "Nunat waten Kevgirqameng",
        "translation": "When villages held the Messenger Feast"
    },
    "222": {
        "startTime": 1655.935,
        "endTime": 1659.41,
        "transcript": "Waten ukut nunalget",
        "translation": "This host village like this"
    },
    "223": {
        "startTime": 1659.904,
        "endTime": 1673.177,
        "transcript": "Waniwa waten mean-iqerluku: kelegyukuvet tua-i elpet, camek piyuumatengqerquvet Tuntutuliarmun ayagceciyartuten angutegnek malrugnek kevgagnek.",
        "translation": "Let me give this meaning: if you want to send an invitation, if you have a request, you would send to men, kevgak [messengers], to Tuntutuliar."
    },
    "224": {
        "startTime": 1673.177,
        "endTime": 1680.232,
        "transcript": "Qalurrirlutek tua-i alerqurlukek tuaten, tuaten tua-i.",
        "translation": "Tell them and instruct them [on your requestions], like that."
    },
    "225": {
        "startTime": 1680.232,
        "endTime": 1684.682,
        "transcript": "Ukuk wani kevgak aya'agqamek",
        "translation": "When these two messengers traveled"
    },
    "226": {
        "startTime": 1684.682,
        "endTime": 1696.872,
        "transcript": "Tuani kingunermegni mikelnguq tauna aatii piyuumatii tuani ciunragni ilurii, ilurii aqvaniluku, kevgirniluku.",
        "translation": "The request of a child's father from their home village, they would get and invite his cousin at their destination."
    },
    "227": {
        "startTime": 1696.872,
        "endTime": 1700.872,
        "transcript": "Ayuqeliluku-ll' tua-i tuaten tua-i.",
        "translation": "Then he would [make a request] the same way, like that."
    },
    "228": {
        "startTime": 1700.877,
        "endTime": 1706.507,
        "transcript": "Canek tua-i piyuuterluteng Kevgirqameng",
        "translation": "They would have some requests when they held the Messenger Feast"
    },
    "229": {
        "startTime": 1706.507,
        "endTime": 1715.757,
        "transcript": "Nutegnek, kapkaanarnek, ikamragnek, canek tua-i piyungssaarluteng.",
        "translation": "Guns, steel traps, a sled, they would want various things."
    },
    "230": {
        "startTime": 1716.127,
        "endTime": 1720.042,
        "transcript": "Iluriinun cali ikayuasqelluteng.",
        "translation": "They'd also ask their cousins to help them."
    },
    "231": {
        "startTime": 1720.042,
        "endTime": 1727.742,
        "transcript": "Tua-i-llu Kass'aqsiginermegteggun pingameng pelarvagmek-llu piaqut.",
        "translation": "Then when as they had more Western contact, they'd ask for huge tents."
    },
    "232": {
        "startTime": 1727.747,
        "endTime": 1731.157,
        "transcript": "Pelatekaryugluteng.",
        "translation": "They'd want tents."
    },
    "233": {
        "startTime": 1731.157,
        "endTime": 1738.567,
        "transcript": "Aglirtuusqelluku-llu nutegmek anarrluurquralriamek ugaan' nutaraam.",
        "translation": "They'd also ask him to [?bring] a gun so new that it had the color of feces."
    },
    "234": {
        "startTime": 1738.567,
        "endTime": 1746.337,
        "transcript": "Tua-i-gguq pit wani, tan'gerpiit ciikallrat tunguuq. Tua-i taman' umyuaqluku.",
        "translation": "They said, you know, diarrhea with crowberries is black. That's why [they say that]."
    },
    "235": {
        "startTime": 1746.337,
        "endTime": 1753.192,
        "transcript": "Tuaten tua-i yuraq Kevgiryaraq ayuqellruuq anguvilqallrenka.",
        "translation": "That's what the dance festival, Messenger Feast, was like where I was born."
    },
    "236": {
        "startTime": 1753.192,
        "endTime": 1757.742,
        "transcript": "Tuaten tua-i wiinga-ll' ilagaqaullua tua-i Kevgilrianun.",
        "translation": "I also participated in the Messenger Feast like that."
    },
    "237": {
        "startTime": 1781.342,
        "endTime": 1790.572,
        "transcript": "Angalkut tamakut tamaani yuut atullruit ciuliamta.",
        "translation": "The people back then, our ancestors, practiced shamanism."
    },
    "238": {
        "startTime": 1790.572,
        "endTime": 1796.162,
        "transcript": "Ciuliaput piciatun yuullrunritut au͡gkut.",
        "translation": "Our ancestors back then didn't live any which way."
    },
    "239": {
        "startTime": 1797.202,
        "endTime": 1803.622,
        "transcript": "Tamakut angalkut atullrulliniit ukvekpiarluki.",
        "translation": "They practiced that shamanism with complete faith."
    },
    "240": {
        "startTime": 1805.027,
        "endTime": 1816.647,
        "transcript": "Yuum temiinek ikayuringnaqelriit naulluulrianek, umyuarrliqenrilnguut, umyuarrugceciyuilnguut",
        "translation": "The ones who try to help a sick person's body, those without malicious intent, those who do not think maliciously of others"
    },
    "241": {
        "startTime": 1817.612,
        "endTime": 1830.072,
        "transcript": "Tamakut angalkut atullermeggni yuut piciuluteng atullrulliniit ukvekluki, law-rit-llu aturluki.",
        "translation": "When people practiced that shamanism, they practiced it correctly with faith, and abode by their laws."
    },
    "242": {
        "startTime": 1830.267,
        "endTime": 1843.297,
        "transcript": "Waten cuq'lirituut: tallimani ernerni una anirtungnaqkeseng uluarasqevkenaku.",
        "translation": "They set this time period: they tell the one they're trying to save not to use a knife for five days."
    },
    "243": {
        "startTime": 1843.557,
        "endTime": 1845.907,
        "transcript": "Tua-i tuaten.",
        "translation": "Like that."
    },
    "244": {
        "startTime": 1846.097,
        "endTime": 1854.232,
        "transcript": "Tang-gguq ilii picungami",
        "translation": "Look, they said, since one of them is true"
    },
    "245": {
        "startTime": 1854.232,
        "endTime": 1857.312,
        "transcript": "Iciw' ukaqsigiqerlua qalangssakarnaurtua",
        "translation": "You know, let me come closer to tell it"
    },
    "246": {
        "startTime": 1857.317,
        "endTime": 1863.627,
        "transcript": "Iciw' Agayutem Satan-aq paat'naqellrukii, an'giliurta tauna?",
        "translation": "You know that Satan was God's partner, that head angel?"
    },
    "247": {
        "startTime": 1863.627,
        "endTime": 1872.117,
        "transcript": "Tua-i-llu piciungami ukvekesteńi niisngallinia.",
        "translation": "Then since it's true, he obeys one who believes him."
    },
    "248": {
        "startTime": 1872.117,
        "endTime": 1876.512,
        "transcript": "Piciatun, akusrarutnguluni tau͡gaam atullrunritliniat.",
        "translation": "But they didn't practice it frivolously in any old way."
    },
    "249": {
        "startTime": 1876.512,
        "endTime": 1883.042,
        "transcript": "Tuunritarkateng, qasgimi tuunrilrianek tangtullruunga cauyarluteng.",
        "translation": "The one they're going to use their shaman power on, I used to see shamans call upon their helping spirits with drums in the community house."
    },
    "250": {
        "startTime": 1883.812,
        "endTime": 1886.772,
        "transcript": "Tua-lli-wa-gguq tamaani ciungani",
        "translation": "Then they said that in the past back then"
    },
    "251": {
        "startTime": 1890.867,
        "endTime": 1901.447,
        "transcript": "Tuunritarkaq-gguq piyuasciiglnguq akigarluku qasgitaqaat, arnaq angun-llu, angalkuk malruk.",
        "translation": "They said that two shamans would bring in the one they were going use their power on side by side into the community house, a woman and a man."
    },
    "252": {
        "startTime": 1903.852,
        "endTime": 1912.802,
        "transcript": "Tua-lli-wa-gguq iliini piluaqaumaaqami taukuk imkuk ikayuqlutek caarrluinek imkunek",
        "translation": "Then they said that when (s)he was sometimes [healed] well, those two worked together on his impurities"
    },
    "253": {
        "startTime": 1914.362,
        "endTime": 1918.822,
        "transcript": "Caarrluinek nang'iluku.",
        "translation": "They got rid of all of his impurities."
    },
    "254": {
        "startTime": 1918.827,
        "endTime": 1923.322,
        "transcript": "Piyuasciiganani itleq piyualuni-gguq an'aquq.",
        "translation": "They said the one who couldn't walk coming in would walk out."
    },
    "255": {
        "startTime": 1923.322,
        "endTime": 1927.032,
        "transcript": "Tua-i nangluku naullutii au͡g'arluku.",
        "translation": "They got rid of all of his ailment."
    },
    "256": {
        "startTime": 1927.032,
        "endTime": 1929.212,
        "transcript": "Tuaten tua-i.",
        "translation": "Like that."
    },
    "257": {
        "startTime": 1953.927,
        "endTime": 1958.717,
        "transcript": "Alerquutengqellruukut imumi ayagyuarluta",
        "translation": "We had a traditional isntruction back when we were young"
    },
    "258": {
        "startTime": 1958.717,
        "endTime": 1965.327,
        "transcript": "Arcaqerluku qanikciurun, wall'u cikuliurun, ayaruq",
        "translation": "Especially about a shovel, or an ice pick, a walking staff"
    },
    "259": {
        "startTime": 1965.327,
        "endTime": 1972.062,
        "transcript": "Ayaruq-llu tamana qanrutketullruat unguvauniluku yugmun.",
        "translation": "They also spoke about that staff as a life[line] for a person."
    },
    "260": {
        "startTime": 1972.062,
        "endTime": 1979.592,
        "transcript": "Cali-llu waniw' ukut arcaqerluki alerquutektullrit:",
        "translation": "Also, this was one of their important instructions:"
    },
    "261": {
        "startTime": 1980.872,
        "endTime": 1993.972,
        "transcript": "Iciw' imarnitet wangkuta Yugcetun, au͡gkut avani makunek Kass'artarnek pingvailegmek tamakut tua-i tamaa-i imarnitet atutullrulliniit.",
        "translation": "You know, [what we call] imarnitet in Yup'ik, people used to use those seal gut rain parkas back then before they had Western raingear."
    },
    "262": {
        "startTime": 1994.397,
        "endTime": 1999.992,
        "transcript": "Tua-i-llu wangkuta Kass'angumariluku maa-i yuurtellriani",
        "translation": "Then for those of us who were born after Western contact"
    },
    "263": {
        "startTime": 1999.992,
        "endTime": 2012.502,
        "transcript": "Angayumta alerqutullruitkut tua-i tamakut tua-i tamaa-i ellalliurcuutet arcaqerluki qelkesqelluki wangkutnun ella assirngalengraan.",
        "translation": "Our parents used to instruct us to especially keep our raingear with us even if the weather looked good."
    },
    "264": {
        "startTime": 2014.402,
        "endTime": 2022.162,
        "transcript": "Tua-i iliini waten iquklicuilan ella up'nerkami wall'u uksuarmi",
        "translation": "Since the weather sometimes doesn't end the way it started in the spring or fall"
    },
    "265": {
        "startTime": 2022.167,
        "endTime": 2032.222,
        "transcript": "Tua-i taukut tua-i tamaa-i arcaqerluki wangkutnuun avaliqesqelluki pitullruit.",
        "translation": "They would tell us to especially have those with us."
    },
    "266": {
        "startTime": 2032.222,
        "endTime": 2041.442,
        "transcript": "Tua-i ayarumek piilkumta tua-i, qaillun nallumciqngamteggu-wa tua-i, cam-llu aarnarqucia nalluluku.",
        "translation": "If we don't have a walkin gstick, since we fumble around, and we don't know how dangerous something is."
    },
    "267": {
        "startTime": 2041.817,
        "endTime": 2053.147,
        "transcript": "Wall'u uksumi ayagakumta qanikciurun ucikerrlainarluku cali ella assingraan pisqelluta.",
        "translation": "Or if we travel in the winter, they would tell us to always carry a shovel though the weather is good."
    },
    "268": {
        "startTime": 2053.147,
        "endTime": 2059.857,
        "transcript": "Arenqiallugeskumta cunawa yuilqumi wall'u pirtunguskakut",
        "translation": "It turned out that if we got into misfortune in the wilderness, or a blizzard starts on us"
    },
    "269": {
        "startTime": 2059.857,
        "endTime": 2070.672,
        "transcript": "Ellaqerruskakut tua-i cali alerquutekluku agnermun, agellranun-wa tua-i arulairesqevkenata.",
        "translation": "When the weather turns on us, they also instruct us not to stop at a small snowbank."
    },
    "270": {
        "startTime": 2070.672,
        "endTime": 2075.892,
        "transcript": "Tau͡gaam-llu tua-i camek kangciramek-llu piilkumta",
        "translation": "But they also said that if we don't have a tarpaulin"
    },
    "271": {
        "startTime": 2075.897,
        "endTime": 2084.967,
        "transcript": "Qanikciurutengqerqumta qengaruk ak'a qengaruurtelleq, tauna elagluku",
        "translation": "If we have a shovel, dig into a snowbank that's already formed"
    },
    "272": {
        "startTime": 2086.487,
        "endTime": 2090.057,
        "transcript": "Iluani tua-i tuani uitasqelluta.",
        "translation": "They told us to stay in that."
    },
    "273": {
        "startTime": 2090.057,
        "endTime": 2096.472,
        "transcript": "Tau͡gaam cali muragmek kapsuutekaanek tauna piluku.",
        "translation": "But also, we should get a wooden [staff] to poke a hole in that."
    },
    "274": {
        "startTime": 2096.472,
        "endTime": 2101.772,
        "transcript": "Kiiriaqan kapurluku elcetaqluku.",
        "translation": "When it gets hot, poke holes to let the [stale] air out."
    },
    "275": {
        "startTime": 2101.847,
        "endTime": 2112.997,
        "transcript": "Tua-i tamaa-i tamakut arcaqerluki wangkuta alerquutekellruaput, au͡gkunun-wa tua-i ciuliamteńun.",
        "translation": "Those were the important traditional instructions given to us from our ancestors back then."
    },
    "276": {
        "startTime": 2138.997,
        "endTime": 2143.957,
        "transcript": "Waten-am umyuangua up'nerkaq kiagniararluku:",
        "translation": "I had this thought last spring on the verge of summer:"
    },
    "277": {
        "startTime": 2144.46,
        "endTime": 2151.29,
        "transcript": "\"Angu ataki tang pavavet pissualallma iliinun kiakan",
        "translation": "\"Oh my, one of my old hunting grounds inland, when summer sets"
    },
    "278": {
        "startTime": 2152.47,
        "endTime": 2160.89,
        "transcript": "\"Aguutekun levaacuaralegkun tamana tarritelallma iliit tangerrsartuqaqerlaku.\"",
        "translation": "\"Let me go see one of the places I'd walk around with an open canoe with a small motor.\""
    },
    "279": {
        "startTime": 2161.385,
        "endTime": 2172.675,
        "transcript": "Tua-i-llu kiagan cikuirucan Tuulkessaarmiut kiatiitgun Tevyarakun tevluta Elaayiim kangranun.",
        "translation": "Then when there was no more ice in the summer, we portaged through Tevyaraq upriver from Tuluksak to the headwaters of Elaayak."
    },
    "280": {
        "startTime": 2172.685,
        "endTime": 2175.905,
        "transcript": "We went downriver from there.",
        "translation": "We went downriver from there."
    },
    "281": {
        "startTime": 2177.48,
        "endTime": 2183.75,
        "transcript": "Cetuinanemteńi pengulkumek tekitaqamta arulairlua nacetaqlua.",
        "translation": "When we came across a larger hill as we went downriver, I'd stop and look from that vantage point."
    },
    "282": {
        "startTime": 2184.32,
        "endTime": 2190.75,
        "transcript": "Nacetaqama tekitnaurtua uumek pop-autellermek.",
        "translation": "When I went to look from that vantage point, I'd come across this empty pop can."
    },
    "283": {
        "startTime": 2190.93,
        "endTime": 2202.35,
        "transcript": "Maani-llu kuigmi levaarinanemni tangerrnaurtua napat avayaitni plastic-aaq tevingaluni.",
        "translation": "And as I traveled this river with a boat motor, I would see a plastic [bag] draped over tree branches."
    },
    "284": {
        "startTime": 2202.355,
        "endTime": 2205.015,
        "transcript": "Tuavet nagingalliniluni.",
        "translation": "It was stuck there."
    },
    "285": {
        "startTime": 2205.14,
        "endTime": 2207.8,
        "transcript": "Tamakunek tangaalua.",
        "translation": "I kept seeing those."
    },
    "286": {
        "startTime": 2207.805,
        "endTime": 2212.595,
        "transcript": "Qaillun-llu umyuarteqeksaunii ciuqlirmi tangengellemni.",
        "translation": "And I didn't think anything when I first started seeing them."
    },
    "287": {
        "startTime": 2212.605,
        "endTime": 2223.835,
        "transcript": "Kiituani tang avani uaqsigiluta nacetellrenka tamalkuita pop-autengqerran, pop-autellernek pitangqerran",
        "translation": "Eventualy, you see, as we were far downriver over there, because there were empty pop cans in every vantage point I looked from"
    },
    "288": {
        "startTime": 2223.845,
        "endTime": 2236.305,
        "transcript": "Umyuangua, \"All' atam wangkuta makut irniaput cakneq-lli uqlaussiyaagpaa, ciuliamcetun pivkenateng.\"",
        "translation": "I had the thought, \"Oh my, look at how messy our children are, not like our ancestors.\""
    },
    "289": {
        "startTime": 2239.0,
        "endTime": 2246.79,
        "transcript": "Ukuugut arcaqerluteng: pop-autellret, plastic-aat",
        "translation": "This are the most prominent: empty pop cans, plastic bags"
    },
    "290": {
        "startTime": 2246.8,
        "endTime": 2251.09,
        "transcript": "Atsiyaryaraitni-wa terr'ilitat cali",
        "translation": "In their berry-picking grounds are also diapers"
    },
    "291": {
        "startTime": 2251.1,
        "endTime": 2257.64,
        "transcript": "Qavartallrit-llu carangllirlainarluteng, qemagngavkenateng tamakut.",
        "translation": "And their camping grounds are always filled with debris, without those being put away."
    },
    "292": {
        "startTime": 2258.665,
        "endTime": 2265.505,
        "transcript": "Avani tang ciuliamteńi nuna man'a menuunani.",
        "translation": "Long ago in our ancestors' time, you see, this land was pristine."
    },
    "293": {
        "startTime": 2266.94,
        "endTime": 2270.95,
        "transcript": "Carangllugtaunani. Tamakunek pitaunani.",
        "translation": "There was no debris. There was none of that."
    },
    "294": {
        "startTime": 2270.96,
        "endTime": 2278.29,
        "transcript": "Pop-autellernek, cavilqunek, plastic-aanek, terr'ilitallernek-llu pitaunani.",
        "translation": "There were no empty pop cans, metal things, plastic things, or used diapers."
    },
    "295": {
        "startTime": 2279.46,
        "endTime": 2284.62,
        "transcript": "Tamakut-llu pinginanratni kuvyallernek cali",
        "translation": "And eventually, there were also old drift nets"
    },
    "296": {
        "startTime": 2285.815,
        "endTime": 2294.695,
        "transcript": "Maani tayima kangitmun Kusquqvak, Akula-llu paug͡na tuaten uksurpak civingallernek.",
        "translation": "Here on to the headwaters of the Kuskokwim, and in Akula inland, [nets] that were set all winter."
    },
    "297": {
        "startTime": 2294.71,
        "endTime": 2301.6,
        "transcript": "Uqlarluteng, uqlauciluteng neqnek, nuna-llu man'a uqlarluku.",
        "translation": "They're polluted, pollute nature with fish, and pollute the land."
    },
    "298": {
        "startTime": 2304.07,
        "endTime": 2310.21,
        "transcript": "Akwaugaq-llu au͡gna Matthew Beans-aaq qanemcillermini qanemciuq waten:",
        "translation": "And yesterday, when Matthew Beans was telling his stories, he told this story:"
    },
    "299": {
        "startTime": 2310.215,
        "endTime": 2314.135,
        "transcript": "Tengaurcuutekun-gguq nunanun ayagaaqami",
        "translation": "He said that when he travels to villages by plane"
    },
    "300": {
        "startTime": 2314.15,
        "endTime": 2324.52,
        "transcript": "Nunat mallgiaqamiki tamakunek plastic-aanek kalikallernek tangaangelartuq, nunat mallgiaqamiki",
        "translation": "When he gets close to villages, he sees a lot of those plastic bags and cardboard things, when he gets close to villages"
    },
    "301": {
        "startTime": 2324.53,
        "endTime": 2328.19,
        "transcript": "Anuqem pirtukluki ayagatellri.",
        "translation": "The things the wind blew like a blizzard."
    },
    "302": {
        "startTime": 2329.795,
        "endTime": 2337.245,
        "transcript": "Waten tang umyuangellrulrianga wiinga up'nerkaq tamaaggun tamakunek tangerpakallemni:",
        "translation": "I had this idea last spring when I saw too many of those when I traveled through there:"
    },
    "303": {
        "startTime": 2337.255,
        "endTime": 2345.675,
        "transcript": "Qanrutkarkaurrluki agayuvigmi, wall'u agayuviunrilengraan tamakut apertuagarkaurrluki.",
        "translation": "That I should talk about those in church, or that I should point those out even if it's not at church."
    },
    "304": {
        "startTime": 2373.8,
        "endTime": 2382.98,
        "transcript": "Ciuliaput menuitellruut, nunaseng man'a kencikluku clean up-aarumarrlainarluku.",
        "translation": "Our ancestors were clean, always keeping their land here cleaned up out of reverence."
    },
    "305": {
        "startTime": 2382.985,
        "endTime": 2385.565,
        "transcript": "Piinanermeggni-llu",
        "translation": "And as they did that"
    },
    "306": {
        "startTime": 2387.22,
        "endTime": 2396.76,
        "transcript": "Merteng Kusquqvak, Kusquqvaunrilengraan, nanvat, kuiggaat-llu kencikluki uqlarcetevkenaki.",
        "translation": "They also didn't pollute their water out of reverence, the Kuskokwim, even if it wasn't the Kuskokwim, the lakes and creeks."
    },
    "307": {
        "startTime": 2396.765,
        "endTime": 2400.205,
        "transcript": "Nuna-llu piyararteng uqlarcetevkenaku.",
        "translation": "They also didn't let their hunting-gathering lands become polluted."
    },
    "308": {
        "startTime": 2400.22,
        "endTime": 2410.16,
        "transcript": "Clean up-aarumarrlainarluku ciuliamta waten qanerluteng: \"Ellam Yuan tangvagaakut.\"",
        "translation": "Our ancestors always kept it cleaned up, saying this: \"The Spirit of the Universe is watching us.\""
    },
    "309": {
        "startTime": 2410.875,
        "endTime": 2415.045,
        "transcript": "Cipciyuunata-gguq Ellam Yuan tangvagaakut.",
        "translation": "They say the Spirit of the Universe watches us, without leaving anyone out."
    },
    "310": {
        "startTime": 2415.055,
        "endTime": 2421.925,
        "transcript": "Bible-aani naaqilartut tayima elisngalruut, wiinga-llu naaqilartua.",
        "translation": "Those who are knowledgeable read the Bible, and I read it too."
    },
    "311": {
        "startTime": 2421.935,
        "endTime": 2425.445,
        "transcript": "Psalms 24-aami waten qanertuq:",
        "translation": "It says this in Psalms 24:"
    },
    "312": {
        "startTime": 2425.455,
        "endTime": 2435.175,
        "transcript": "\"Agayutem nuna pikaa, tamakunelnguut-llu tamalkuita tuani-llu enengqellriit tamalkuita elliin pikai.\"",
        "translation": "\"To Jehovah belong the earth and that which fills it, the productive land and those dwellingin it.\" [NWT]"
    },
    "313": {
        "startTime": 2436.28,
        "endTime": 2443.53,
        "transcript": "Nakleng wangkuta mat'um nalliini nunamteńek uqlarilriani.",
        "translation": "How pitiful, we who pollute our land these days."
    },
    "314": {
        "startTime": 2443.68,
        "endTime": 2454.81,
        "transcript": "Ukvelrianek aterpagingaluta, ukvelriaruciqukut-qaa air-arput nunaput-llu uqlarluku?",
        "translation": "Calling ourselves believers, will we be believers who pollute our air and lands?"
    },
    "315": {
        "startTime": 2454.9,
        "endTime": 2464.21,
        "transcript": "Maaten umyuangcartua, ukvelriani wangkuta tuaten air-angqerrngaitellinilriakut.",
        "translation": "I pondered and realized that we believes will not have [polluted] air like that."
    },
    "316": {
        "startTime": 2464.22,
        "endTime": 2471.58,
        "transcript": "Nunavut, uitavigput uksumi, pissurviput-llu yuilqumi",
        "translation": "Our land, where we stay in the winter, and our hunting grounds in the wilderness"
    },
    "317": {
        "startTime": 2471.805,
        "endTime": 2478.375,
        "transcript": "Enecetun clean up-aarumalriatun ayuqevkararkauyaaqelliniarput",
        "translation": "We must keep it like a cleaned up house"
    },
    "318": {
        "startTime": 2478.385,
        "endTime": 2484.805,
        "transcript": "Wangkuta air-arput-ll', pissuryaraput, neqsurviput, Kusquqvagput-llu.",
        "translation": "And our air, our hunting grounds, our fishing grounds, and our Kuskokwim River."
    },
    "319": {
        "startTime": 2484.82,
        "endTime": 2492.7,
        "transcript": "Mat'um-llu nalliini ayainanemni Kusquqvagkun tangerrnaurtua pop-autelleq man'a at'reskii.",
        "translation": "And these days, as I go on the Kuskokwim, I would see an empty pop can drifting down here."
    },
    "320": {
        "startTime": 2492.705,
        "endTime": 2499.375,
        "transcript": "Amta-llu nerangnaqvikluku, akingengnaqvikluku-llu.",
        "translation": "And yet, it's our food source, and our income source."
    },
    "321": {
        "startTime": 2499.385,
        "endTime": 2503.505,
        "transcript": "Ik'atak' qalquni qaillun piciqa?",
        "translation": "How foul, what will happen when it rusts?"
    },
    "322": {
        "startTime": 2503.66,
        "endTime": 2507.62,
        "transcript": "Au͡gkut tang ciuliaput waten qanelriit:",
        "translation": "You see, our ancestors back then said this:"
    },
    "323": {
        "startTime": 2507.625,
        "endTime": 2511.915,
        "transcript": "Makut-gguq neqet cumacitartut.",
        "translation": "They said that these fish are easily repulsed."
    },
    "324": {
        "startTime": 2511.925,
        "endTime": 2522.105,
        "transcript": "Man'a-gguq kuik assiitellriamek camek aungqerqan, neqet aturngaitaat unguvatekngamegteggu meq",
        "translation": "They said that if there's anything bad in the river, the fish won't go in it because water is their livelihood"
    },
    "325": {
        "startTime": 2522.12,
        "endTime": 2527.96,
        "transcript": "Nallunrilameng atuqunegteggu tuquciqngameng kangillipailegmeteggu.",
        "translation": "Because they know that if they go on it, they'll die before they reach its headwaters."
    },
    "326": {
        "startTime": 2527.965,
        "endTime": 2533.745,
        "transcript": "Atusciigataat-gguq uqlalria meq neqet avaken ayagluteng.",
        "translation": "They said fish have never been able to go in polluted water since a long time ago."
    },
    "327": {
        "startTime": 2533.76,
        "endTime": 2539.53,
        "transcript": "Makut nunam auluklerkaa mer'em-llu auluklerkaa",
        "translation": "Taking care of the land and taking care of the water"
    },
    "328": {
        "startTime": 2539.54,
        "endTime": 2550.9,
        "transcript": "Avaken ayagluku ciuliamteńek, millions of millions year pellugluteng taringumarillerteng inerquutekaat piciulria.",
        "translation": "Starting from from our ancestors long ago, they have admonishments of what they've understood over the course of millions millions [of] year[s], true things."
    },
    "329": {
        "startTime": 2550.905,
        "endTime": 2558.135,
        "transcript": "Piciulriit tau͡gaam inerquutek'larait, taringelteng, nakmiin iimegteggun tangaalteng.",
        "translation": "They only have admonishments about true things, what they understood, what they've seen with their own eyes."
    },
    "330": {
        "startTime": 2558.145,
        "endTime": 2565.995,
        "transcript": "Taumek tuaten ayuqngan man'a mat'um nalliini murilkeqernaurtukut.",
        "translation": "Since it's like that these days, let's take a look around."
    },
    "331": {
        "startTime": 2566.005,
        "endTime": 2572.025,
        "transcript": "Cairusngiinartuq, neqairusngiinarluni-llu mat'um nalliini",
        "translation": "Things are depleting, and fish are depleting these days"
    },
    "332": {
        "startTime": 2572.04,
        "endTime": 2578.56,
        "transcript": "Merput nunaput-llu kencikenrilamteki, iqaurcamteggu wangkuta.",
        "translation": "Because we don't revere the water and our lands, because we've polluted them."
    },
    "333": {
        "startTime": 2605.385,
        "endTime": 2609.245,
        "transcript": "Makut-qaa ekuasciigataput?",
        "translation": "Can't we incinerate these?"
    },
    "334": {
        "startTime": 2609.26,
        "endTime": 2618.97,
        "transcript": "Wall'u nunapigmun patulluki unicunaqsaaqaput nunavut clean up-aarumavkarluku.",
        "translation": "Or, we must leave cover them up under the land to keep our land cleaned up."
    },
    "335": {
        "startTime": 2619.83,
        "endTime": 2628.5,
        "transcript": "Nallunrituci enengqellrianek assilrianek, caranglliisqumanritarci enesi.",
        "translation": "You with good houses know that you don't want your house to be dirty."
    },
    "336": {
        "startTime": 2628.89,
        "endTime": 2636.97,
        "transcript": "Arcaqanrulria waniwa: nunasi, air-arci-llu, pissurvigci.",
        "translation": "These are more important: your land, your air, your hunting grounds."
    },
    "337": {
        "startTime": 2636.975,
        "endTime": 2647.625,
        "transcript": "Tuaten nutaan arcaqanruluku murilkarkauyaaqerci nakmiin qavarvigpeceńi enemi clean up-aarumavkarluku.",
        "translation": "You must carefully watch than more than your own bed in your home, and keep it cleaned up."
    },
    "338": {
        "startTime": 2647.635,
        "endTime": 2655.995,
        "transcript": "Waten mat'um nalliini nunavut uqlangan Agayutem atawaqertesciigataa.",
        "translation": "Since our land is polluted these days, God cannot bless it."
    },
    "339": {
        "startTime": 2656.01,
        "endTime": 2667.23,
        "transcript": "Cat ikegliinavkarluki, neqet ikegliinavkarluki, makut-llu cali naunraat tuar ikegliinavkarluki.",
        "translation": "He decreases things, decreases fish populations, and seems to decrease these plants."
    },
    "340": {
        "startTime": 2667.235,
        "endTime": 2671.825,
        "transcript": "Atawaqertesciiganaku nuna uqlalria.",
        "translation": "He cannot bless a polluted land."
    },
    "341": {
        "startTime": 2672.015,
        "endTime": 2681.025,
        "transcript": "Allamun yugmun wall'u Kass'amun ellinrillaut, wangkutnun tau͡gaam nunakestainun.",
        "translation": "Let us not put it upon another person or to the West, but to us who live in this land."
    },
    "342": {
        "startTime": 2681.035,
        "endTime": 2692.495,
        "transcript": "Tamakunek carririarnek, murilkiarkanek-llu wangkutnun tau͡gaam ellilaut man'a, allamun yugmun pivkenaku, nugtartevkenaku.",
        "translation": "Cleaning those up, and watching them, let's put it upon ourselves, not shift it to someone else."
    },
    "343": {
        "startTime": 2692.72,
        "endTime": 2704.72,
        "transcript": "Wangkuta murilkenrilucimcetun, ayagyuaput-llu ayuqucirtunrilucimteńek tamatumek kencikluku atu'urkaatnek tuaten ellircetarput",
        "translation": "As wou don't watch over it, and as we don't instruct our youth to utilize it reverantly, we've let it become like that"
    },
    "344": {
        "startTime": 2704.725,
        "endTime": 2708.535,
        "transcript": "Wangkuta iirusngiimteki ayagyuaput.",
        "translation": "Because we keep [knowledge] from our youth."
    },
    "345": {
        "startTime": 2735.475,
        "endTime": 2747.045,
        "transcript": "Kitak' waken ayagluta ayuqucirturnauput nunam clear-arluku, menuunaku pisqelluku.",
        "translation": "From here on out, let's instruct them to keep the land clear, and pristine."
    },
    "346": {
        "startTime": 2747.055,
        "endTime": 2758.075,
        "transcript": "Nallunaitqapigmek nunavut menuiruskan Agayutem atawaqerceciiqaa ciuliamcetun cat amllerivkarluki.",
        "translation": "Undoubtedly, when our land becomes pristine, God will bless it with abundance like our ancestors."
    },
    "347": {
        "startTime": 2758.09,
        "endTime": 2766.6,
        "transcript": "Ca tamalkuan enuryugpek'naku, paivngavkarluku wangkuta atutukput maani nunami.",
        "translation": "He will not let anything become scarce, but what we use here in this land will be available."
    },
    "348": {
        "startTime": 2766.61,
        "endTime": 2773.2,
        "transcript": "Yaqulget, ungungssiaraat, tuntut, imarmiutaat-llu tuaten piyugngaut.",
        "translation": "Birds, little animals, caribout, and minks can [be plentiful] like that."
    },
    "349": {
        "startTime": 2773.21,
        "endTime": 2777.6,
        "transcript": "Avani ciuliamteńi qanengssaitni qanlartut",
        "translation": "In our ancestors' stories back then, they say"
    },
    "350": {
        "startTime": 2777.61,
        "endTime": 2787.55,
        "transcript": "Taluyaarait-llu-gguq muirluteng igesciigaliaqameng cangenrilalliniut imarmiutarnek.",
        "translation": "When their fish traps were full and couldn't take in any more, they'd stop catching minks."
    },
    "351": {
        "startTime": 2787.555,
        "endTime": 2790.465,
        "transcript": "Amllerrluteng cat tamarmeng avani.",
        "translation": "Everything was in plenty back then."
    },
    "352": {
        "startTime": 2790.475,
        "endTime": 2798.785,
        "transcript": "Nuna-wa clear up-aaran waten menuunani Agayutem atawaqercecimaluku tuaten.",
        "translation": "Since the land was cleared up and pristine like this, God blessed it like that."
    },
    "353": {
        "startTime": 2798.795,
        "endTime": 2804.075,
        "transcript": "Ca tamalkuan kemget alerquutnguluteng.",
        "translation": "Every kind of meat had an instruction."
    },
    "354": {
        "startTime": 2804.09,
        "endTime": 2810.08,
        "transcript": "Aturngailkeput cipneput teq'erluki unitesqelluki.",
        "translation": "They said to leave the excess that we won't use in a pit."
    },
    "355": {
        "startTime": 2810.09,
        "endTime": 2817.67,
        "transcript": "Yuilqumi-llu tuntum enranek wall'u allam ungungssiaraam enranek tangerqumta",
        "translation": "And if we see a caribou bone, or some other animal bone in the wilderness"
    },
    "356": {
        "startTime": 2817.675,
        "endTime": 2824.415,
        "transcript": "Canimelkii nanvartailkan, nunamun pakiulluku tauna unitesqelluku.",
        "translation": "If there's no lake nearby, they said to leave it buried into the land."
    },
    "357": {
        "startTime": 2824.43,
        "endTime": 2829.82,
        "transcript": "Canimelkii nanvartangqerran tuavet nanvamun eneq egcartuusqelluku.",
        "translation": "If there's lake nearby, they said to throw that bone into that lake."
    },
    "358": {
        "startTime": 2829.83,
        "endTime": 2838.8,
        "transcript": "Alerquutekluku ciuliamta tuaten nuna menuunaku man'a tangllerteng pisqelluku.",
        "translation": "Our ancestors had that instruction to keep the land that they saw pristine."
    },
    "359": {
        "startTime": 2838.81,
        "endTime": 2846.36,
        "transcript": "Tamatumek tamaa-i qanerkanglua wii utertua up'nerkaq pektellemni tamatumek.",
        "translation": "I got the intention to say that when I returned home from my travels last spring."
    },
    "360": {
        "startTime": 2846.37,
        "endTime": 2857.96,
        "transcript": "Waten ayuqluku uqlartaluta aulukestemta, nunam-llu piliaqestiin, pikestiin atawaqertesciigataa.",
        "translation": "Our caretakers [did not let us] let it be this polluted, the creator, the owner of the land cannot bless it."
    },
    "361": {
        "startTime": 2884.9,
        "endTime": 2896.3,
        "transcript": "Tua-i-wa ayagyuamteńun makunun waniw' tua-i quyatekngamku alerquutekqeryuumiryaaqaqa tua-i cali atauciq.",
        "translation": "Since I am thankful for this to our youth here, I want to give this one more instruction."
    },
    "362": {
        "startTime": 2896.625,
        "endTime": 2900.285,
        "transcript": "Tua-i cali wii aipangqerraallemni",
        "translation": "When I first got married"
    },
    "363": {
        "startTime": 2902.4,
        "endTime": 2907.74,
        "transcript": "Tua-i-wa aipanglua, wall' irnianglua-llu",
        "translation": "When I got married, or when I also had children"
    },
    "364": {
        "startTime": 2907.745,
        "endTime": 2916.045,
        "transcript": "Atama ug'um mulngakevkenii qanrutetullruanga tua-i tamaa-i tamaani",
        "translation": "Since my father downriver wouldn't hold back when instructing me back then"
    },
    "365": {
        "startTime": 2916.06,
        "endTime": 2924.21,
        "transcript": "Qalarut'lallruanga waten: mikelnguq, irniangekumegnuk pitsaqevkenanuk",
        "translation": "He would instruct me like this: a child, should we happen to have children"
    },
    "366": {
        "startTime": 2924.22,
        "endTime": 2935.49,
        "transcript": "Qialuni itengraan apqaureskevkenaku, wall'u qaillun picianek, kitumun-llu picianek aptesqevke[naku].",
        "translation": "He said not to ask them questions though they come in crying, or ask what happened and who did it."
    },
    "367": {
        "startTime": 2935.5,
        "endTime": 2939.21,
        "transcript": "Tua-i-wa eyurnakluku pisqevkenaku.",
        "translation": "He said not to feel defensive over them."
    },
    "368": {
        "startTime": 2939.22,
        "endTime": 2948.38,
        "transcript": "Atam-gguq eyurnakluku pilaqumegtegu taum mikelngucuaraam ukvercugngariniaraakuk.",
        "translation": "Watch, he said, if we defend them, that little child will become able to have us believe [lies]."
    },
    "369": {
        "startTime": 2948.385,
        "endTime": 2954.775,
        "transcript": "Ayainanmegni yugnikek'ngamegnun umyuarpuk assiicecugngarivkarluku.",
        "translation": "As we go, they could make us upset at one of our friends."
    },
    "370": {
        "startTime": 2955.455,
        "endTime": 2962.605,
        "transcript": "Tua-i-llu cali pinarikuni cali, maa-i-llu elitnaungelriit.",
        "translation": "Then when it's time for them, they also go to school now."
    },
    "371": {
        "startTime": 2963.555,
        "endTime": 2973.105,
        "transcript": "Inerqulangraatni-gguq yuut niicuiciiquq, tua-i-gguq-wa wangkugnek eyurtekangqerrami.",
        "translation": "He said that (s)he will not listen though people admonish them, because he said we are their defenders."
    },
    "372": {
        "startTime": 2974.335,
        "endTime": 2985.025,
        "transcript": "Tua-i tamaa-i tamana arcaqerluku qanrutkeqeryuumiamku quyatekngamku tua-i taiqallertek qanrutkartaqa.",
        "translation": "Since I especially wanted to say thank out of gratitude for your coming, I just spoke about it."
    },
    "373": {
        "startTime": 3012.155,
        "endTime": 3018.635,
        "transcript": "Yaa, mat'umun-wa tau͡gaam qanrutkelallratnun arcaqerluku tua-i maa-i",
        "translation": "Well, to this thign they talked about, especially now"
    },
    "374": {
        "startTime": 3019.67,
        "endTime": 3029.1,
        "transcript": "Mat'umek piitqapigtellrunricaaqut wangkuta imumi yuurtellemteńi Kass'angumariluku yuurtellruamta.",
        "translation": "They didn't have absolutely none of these when we were born, because we were born after Western contact."
    },
    "375": {
        "startTime": 3029.11,
        "endTime": 3037.95,
        "transcript": "Tau͡gaam makunek massiinangellrata-llu cukalriani, tamaa-i tamatum arcaqerluki",
        "translation": "But when they got these fast motors, that especially"
    },
    "376": {
        "startTime": 3038.945,
        "endTime": 3046.985,
        "transcript": "Ayagassuutetgun-wa tua-i makutgun pingellrata arcaqerluki yuut kanvelriaceun pingevkarai.",
        "translation": "Getting these traveling implements and vehicles are especially what's making people drop [dead]."
    },
    "377": {
        "startTime": 3047.0,
        "endTime": 3055.85,
        "transcript": "Cali-ll' mat'umek usviitnarqellriamek tamaa-i atullrata tuaten pivkallii.",
        "translation": "Also, them using mind-altering substances probably makes them do that too."
    },
    "378": {
        "startTime": 3055.86,
        "endTime": 3064.38,
        "transcript": "Imumi tua-i nallemni-llu wii Mamterillerni kanani kipusviit-llu tamarmeng tangiviullruyaaqut.",
        "translation": "Back in my time, all of the stores down there in Bethel sold liquor."
    },
    "379": {
        "startTime": 3064.385,
        "endTime": 3075.895,
        "transcript": "Taug͡aam elluatumek ayagassuutaitellruameng tamaani tuaten pilange'rmeng nallulallruut.",
        "translation": "But since they didn't have fast traveling devices back then, though they [sold it] like that, they didn't know [of any accidents]."
    },
    "380": {
        "startTime": 3076.68,
        "endTime": 3086.65,
        "transcript": "Tua-i maa-i alerqualaryaaqaput makut irniaput, tua-i wiinga-ll' ukut irnianka tua-i qalarutaqluki",
        "translation": "We do instruct our children here, and I also speak to my children"
    },
    "381": {
        "startTime": 3086.66,
        "endTime": 3092.72,
        "transcript": "Tau͡gaam watuam nalliini tuacetun, wiinga-llu angayuqamtun",
        "translation": "But these days like that, and like my parents"
    },
    "382": {
        "startTime": 3093.681,
        "endTime": 3098.451,
        "transcript": "Unisteka au͡gna tangvallruyaaqaqa, wangnek-llu.",
        "translation": "I watched my late parent [give instruction] and myself."
    },
    "383": {
        "startTime": 3098.461,
        "endTime": 3105.361,
        "transcript": "Tau͡gaam tuacetuqapiar maa-i pisciigatanka elliitun.",
        "translation": "But now, I can't [instruct] them exactly like him."
    },
    "384": {
        "startTime": 3106.266,
        "endTime": 3116.446,
        "transcript": "Tua-i-wa cangayullerkaat wiinga pitekluku, wall'u iqlutmuqertellerkaat pitekluku piyaaqellrianga. Cunaw' wiinga alarrlua.",
        "translation": "I did that because they might feel offended, or that they might go the wrong way. Turns out, I made a mistake."
    },
    "385": {
        "startTime": 3116.981,
        "endTime": 3128.111,
        "transcript": "Yaa, tua-i kenkekumki waten aarnarqellria tamalkuan mulngakevkenaki tua-i qalarutarkauyaaqellinianka",
        "translation": "Yes, if I love them, then I must not hold back talking to them about every danger"
    },
    "386": {
        "startTime": 3128.121,
        "endTime": 3131.961,
        "transcript": "Tua-i umyuaqellerkaat tau͡gaam ellaita pitekluku.",
        "translation": "So that they will remember them."
    },
    "387": {
        "startTime": 3132.166,
        "endTime": 3144.496,
        "transcript": "Tua-i maa-i amllermi, tua-i-wa waten angayuqameggnek saagilriit elluarrluteng yuuyuitelliniut.",
        "translation": "Many times now, those who separate from their parents do not live right."
    },
    "388": {
        "startTime": 3144.506,
        "endTime": 3153.606,
        "transcript": "Cali-llu qanruyuteteng atunrilkait ellaita waten tua-i cailkamun ellilriacetun ayuqaqluteng.",
        "translation": "Also, those who do not practice the traditional wisdom passed down to them are like they're [lost] underfoot."
    },
    "389": {
        "startTime": 3154.301,
        "endTime": 3167.811,
        "transcript": "Cali-llu niitessaanrilnge'rmi nunanek allanek, napartem kangrani arulalriacetun tauna yuk ayuqaqluni qanruyutni atunritaqamiu.",
        "translation": "And though one tries not to be heard of in other villages, it's like that person is shuddering at the top of a pole when they don't practice traditional wisdom."
    },
    "390": {
        "startTime": 3168.305,
        "endTime": 3177.5,
        "transcript": "Tau͡gken imna qanruyutmi aturtii catailngurcetun, nunaqliq'ngermi-llu maani catailngurcetun ayuqluni.",
        "translation": "However, one who practices their traditional wisdom is like they're not there, and like they're not there even in neighboring villages."
    },
    "391": {
        "startTime": 3201.494,
        "endTime": 3205.931,
        "transcript": "Makut nunam auluklerkaa mer'em-llu auluklerkaa",
        "translation": "Taking care of the land, and taking care of the water"
    },
    "392": {
        "startTime": 3205.941,
        "endTime": 3217.338,
        "transcript": "Avaken ayagluku ciuliamteńek millions of millions year pellugluteng taringumarillerteng inerquutekaat piciulria.",
        "translation": "Starting from from our ancestors long ago, they have admonishments of what they've understood over the course of millions millions [of] year[s], true things."
    },
    "393": {
        "startTime": 3217.35,
        "endTime": 3224.427,
        "transcript": "Piciulriit tau͡gaam inerquutek'larait, taringelteng, nakmiin iimegteggun tangaalteng.",
        "translation": "They only have admonishments about true things, what they understood, what they've seen with their own eyes."
    },
    "394": {
        "startTime": 3224.439,
        "endTime": 3232.328,
        "transcript": "Taumek tuaten ayuqngan man'a mat'um nalliini murilkeqernaurtukut.",
        "translation": "Since it's like that these days, let's take a look around."
    },
    "395": {
        "startTime": 3232.343,
        "endTime": 3238.354,
        "transcript": "Cairusngiinartuq, neqairusngiinarluni-llu mat'um nalliini",
        "translation": "Things are depleting, and fish are depleting these days"
    },
    "396": {
        "startTime": 3238.357,
        "endTime": 3244.977,
        "transcript": "Merput nunaput-llu kencikenrilamteggu iqaurcamteggu wangkuta.",
        "translation": "Because we don't revere the water and our land and pollute them."
    },
    "397": {
        "startTime": 3246.017,
        "endTime": 3249.872,
        "transcript": "Makut-qaa ekuasciigataput?",
        "translation": "Can't we incinerate these?"
    },
    "398": {
        "startTime": 3249.886,
        "endTime": 3259.663,
        "transcript": "Wall'u nunapigmun patulluki unicunaqsaaqaput nunavut clean up-aarumavkarluku.",
        "translation": "Or, we should leave them buried in the land to keep our land cleaned up."
    },
    "399": {
        "startTime": 3260.258,
        "endTime": 3268.967,
        "transcript": "Nallunrituci enengqellriani assilrianek, caranglliisqumanritarci enesi.",
        "translation": "You with good houses know that you don't want your house to be dirty."
    },
    "400": {
        "startTime": 3269.341,
        "endTime": 3277.263,
        "transcript": "Arcaqanrulria waniwa: nunasi, air-arci-llu, pissurvigci.",
        "translation": "This is more important: your land, your air, and your hunting grounds."
    },
    "401": {
        "startTime": 3277.275,
        "endTime": 3288.086,
        "transcript": "Tuaten nutaan arcaqanruluku murilkarkauyaaqerci nakmiin qavarvigpeceńi enemi clean up-aarumavkarluku.",
        "translation": "You must especially watch over it more than your own beds at home, keeping it cleaned up."
    },
    "402": {
        "startTime": 3288.096,
        "endTime": 3296.507,
        "transcript": "Waten mat'um nalliini nunavut uqlangan, Agayutem ataweqertesciigataa.",
        "translation": "Since our land is polluted like this these days, God cannot bless it."
    },
    "403": {
        "startTime": 3296.518,
        "endTime": 3307.873,
        "transcript": "Cat ikegliinavkarluki, neqet ikegliinavkarluki, makut-llu cali naunraat tuar ikegliinavkarluki.",
        "translation": "He depletes things, depletes fish, and seems to deplete these plants."
    },
    "404": {
        "startTime": 3307.888,
        "endTime": 3312.199,
        "transcript": "Atawaqertesciiganaku nuna uqlalria.",
        "translation": "He cannot bless a polluted land."
    },
    "405": {
        "startTime": 3312.206,
        "endTime": 3321.473,
        "transcript": "Allamun yugmun wall'u Kass'amun pinrillaut, wangkutnun tau͡gaam nunakestainun.",
        "translation": "Let's not put it upon another pesron or the West, but upon ourselves who live in the land."
    },
    "406": {
        "startTime": 3321.479,
        "endTime": 3333.034,
        "transcript": "Tamakunek carririarkanek, murilkiarkanek-llu wangkutnun tau͡gaam ellilaut man'a, allamun yugmun pivkenaku, nugtartevkenaku.",
        "translation": "Let's put it upon ourselves to clean those up, to watch over them, not move [the responsibility] to another person."
    },
    "407": {
        "startTime": 3333.044,
        "endTime": 3345.326,
        "transcript": "Wangkuta murilkenrilucimcetun, ayagyuaput-llu ayuqucirtunrilucimteńek tamatumek kencikluku atu'urkaatnek tuaten ellircetarput",
        "translation": "Since we don't watch over it, and since we don't instruct our youth to utilize it reverently, we've let it become like that"
    },
    "408": {
        "startTime": 3345.344,
        "endTime": 3349.122,
        "transcript": "Wangkuta iirusngiimteki ayagyuaput.",
        "translation": "Because we keep it from our youth."
    },
    "409": {
        "startTime": 3349.14,
        "endTime": 3360.77,
        "transcript": "Kitak' waken ayagluta ayuqucirturnauput nunam clear-arluku, menuunaku pisqelluku.",
        "translation": "From here on out, let's instruct them to keep the land clear and pristine."
    },
    "410": {
        "startTime": 3360.78,
        "endTime": 3371.65,
        "transcript": "Nallunaitqapigmek nunavut menuiruskan, Agayutem atawaqerceciiqaa ciuliamcetun cat amllerivkarluki.",
        "translation": "Undoubtedly, when our land becomes pristine, God will bless it by makes things plentiful like our ancestors[' time]."
    },
    "411": {
        "startTime": 3371.66,
        "endTime": 3380.23,
        "transcript": "Ca tamalkuan enuryugpek'naku, paivngavkarluku wangkuta atutukput maani nunami.",
        "translation": "He will not make anything scarce, but what we use here on this land will be available."
    },
    "412": {
        "startTime": 3380.24,
        "endTime": 3386.76,
        "transcript": "Yaqulget, ungungssiaraat, tuntut, imarmiutaat-llu tuaten piyugngaut.",
        "translation": "Birds, little animals, caribout, and minks can [be plentiful] like that."
    },
    "413": {
        "startTime": 3386.765,
        "endTime": 3391.385,
        "transcript": "Avani ciuliamteńi qanengssaitni qanlartut",
        "translation": "In our ancestors' stories back then, they say"
    },
    "414": {
        "startTime": 3391.4,
        "endTime": 3401.13,
        "transcript": "Taluyaarait-llu-gguq muirluteng igesciigaliaqameng cangenrilalliniut imarmiutarnek.",
        "translation": "They said that when their fish traps were full and couldn't take in any more, they would stop catching minks."
    },
    "415": {
        "startTime": 3401.14,
        "endTime": 3404.08,
        "transcript": "Amllerrluteng cat tamarmeng avani.",
        "translation": "Everything was plentiful back then."
    },
    "416": {
        "startTime": 3404.085,
        "endTime": 3412.475,
        "transcript": "Nuna-wa clear up-aaran waten menuunani, Agayutem atawaqercecimaluku tuaten.",
        "translation": "Since the land was cleared up and pristine like this, God blessed it like that."
    },
    "417": {
        "startTime": 3412.485,
        "endTime": 3417.725,
        "transcript": "Ca tamalkuan kemget alerquutnguluteng.",
        "translation": "Every kind of meat had an instruction."
    },
    "418": {
        "startTime": 3417.733,
        "endTime": 3423.673,
        "transcript": "Aturngailkeput cipneput teq'erluki unitesqelluki.",
        "translation": "They told us to leave our excess that we won't use buried in pits."
    },
    "419": {
        "startTime": 3423.688,
        "endTime": 3431.418,
        "transcript": "Yuilqumi-llu tuntum enranek, wall'u allam ungungssiaraam enranek tangerqumta",
        "translation": "And if we see a caribou bone, or the bone of another animal in the wilderness"
    },
    "420": {
        "startTime": 3431.428,
        "endTime": 3437.948,
        "transcript": "Canimelkii nanavartailkan nunamun pakiulluku tauna unitesqelluku.",
        "translation": "If there's no lake near it, they said to leave it buried into the ground."
    },
    "421": {
        "startTime": 3437.953,
        "endTime": 3443.493,
        "transcript": "Canimelkii nanvartagnqerran tuavet nanvamun eneq egcartuusqelluku.",
        "translation": "If there's a lake near it, they said to go throw the bone into that lake."
    },
    "422": {
        "startTime": 3443.508,
        "endTime": 3452.478,
        "transcript": "Alerquutekluku ciuliamta tuaten, nuna menuunaku man'a tangllerteng pisqelluku.",
        "translation": "Our ancestors gave that instruction to keep the land that they saw here pristine."
    },
    "423": {
        "startTime": 3452.488,
        "endTime": 3460.068,
        "transcript": "Tamatumek tamaa-i qanerkanglua wii utertua up'nerpak pektellemni tamatumek.",
        "translation": "I got the intention to say that when I returned home from my travels last spring."
    },
    "424": {
        "startTime": 3460.079,
        "endTime": 3471.329,
        "transcript": "Waten ayuqluku uqlartaluku aulukestemta, nunam-llu piliaqestiin, pikestiin atawaqertesciigataa.",
        "translation": "With [the land] polluted like this, our caretaker, and the creator and owner of the land cannot bless it."
    },
    "425": {
        "startTime": 3472.379,
        "endTime": 3474.429,
        "transcript": "Tamaa-i tamana.",
        "translation": "There you have it."
    },
    "426": {
        "startTime": 3474.439,
        "endTime": 3485.679,
        "transcript": "Taumta-llu cali mat'um tang nunam clean up-aallra akituqapiarallinilria.",
        "translation": "Then also, you see, cleaning up this land is very expensive."
    },
    "427": {
        "startTime": 3487.214,
        "endTime": 3498.424,
        "transcript": "Avani tang mat'um nalliini nunani-am clean up-aarilrianek akingurluteng tangaalalrianga.",
        "translation": "Over there, you see, this year, I see people earning money by cleaning up the land."
    },
    "428": {
        "startTime": 3498.434,
        "endTime": 3500.994,
        "transcript": "Amta-ll' clean up-aaristeńek aterluteng.",
        "translation": "And yet they're called cleaner uppers."
    },
    "429": {
        "startTime": 3501.009,
        "endTime": 3504.169,
        "transcript": "Aki tau͡gaam tangvagluku watua maa-i.",
        "translation": "They only have their eyes on money these days."
    },
    "430": {
        "startTime": 3504.174,
        "endTime": 3509.544,
        "transcript": "Avani tau͡gken ciuliamteńi aki tangvanritaat.",
        "translation": "In our ancestors' time back then, however, they didn't look at money."
    },
    "431": {
        "startTime": 3510.454,
        "endTime": 3517.894,
        "transcript": "Una tau͡gaam akaarnun yuuqallerkarteng kiingan tangvagaat au͡gkut ciuliamta.",
        "translation": "Instead, our ancestors back then kept their eyes on how they could live for a long time."
    },
    "432": {
        "startTime": 3520.359,
        "endTime": 3522.329,
        "transcript": "Waten ayuqut:",
        "translation": "They were like this:"
    },
    "433": {
        "startTime": 3525.019,
        "endTime": 3533.199,
        "transcript": "Nunani, nunameggni canegmek naumalriartangqerrsuunaku.",
        "translation": "In their villages, they didn't let grass grow."
    },
    "434": {
        "startTime": 3533.204,
        "endTime": 3537.844,
        "transcript": "Clean up-aatuluku can'get nauvkarraarluku nunaseng.",
        "translation": "They'd clean up their villages after letting the grass grow."
    },
    "435": {
        "startTime": 3538.339,
        "endTime": 3543.179,
        "transcript": "Tuamta-llu uksumi tumyarat qanikciurturatuluki.",
        "translation": "Then in the winter, they always shoveled their paths."
    },
    "436": {
        "startTime": 3543.184,
        "endTime": 3548.244,
        "transcript": "Mertaryarait-llu qanikciurturatuluki ciuliamta.",
        "translation": "Our ancestors also always shoveled their paths for hauling water."
    },
    "437": {
        "startTime": 3548.259,
        "endTime": 3553.209,
        "transcript": "Tuaten ayuqngata nuniit atawaqercecimallruuq.",
        "translation": "Because they were like that, their land was blessed."
    },
    "438": {
        "startTime": 3553.219,
        "endTime": 3559.689,
        "transcript": "Tamakut-llu imkut clean up-aartet",
        "translation": "And those who cleaned up"
    },
    "439": {
        "startTime": 3560.789,
        "endTime": 3564.779,
        "transcript": "Waten tamakut qanertut:",
        "translation": "They said this:"
    },
    "440": {
        "startTime": 3564.789,
        "endTime": 3575.489,
        "transcript": "\"Caranglliuryunqeggluten, clean up-aaryunqeggluten yuukina aki umyuaqevkenaku. Akituuq clean up-aarilleq.",
        "translation": "\"Live your life with a propensity do [clean up] debris, to clean up without thinking of money. Cleaning up is expensive."
    },
    "441": {
        "startTime": 3575.494,
        "endTime": 3583.274,
        "transcript": "\"Waten ciunren, ukatmun takuyallren tamarmi neqkangqerrnaurtuq.",
        "translation": "\"So that in the future, when you look back, you will have food every time."
    },
    "442": {
        "startTime": 3583.959,
        "endTime": 3593.519,
        "transcript": "\"Tuamta-llu neqtangqerrnginanrani tuaten ciunren, akaarnun unguvaqerciquten nunami.\"",
        "translation": "\"Then as there is food like that in your future, you will live for a long time on earth.\""
    },
    "443": {
        "startTime": 3593.524,
        "endTime": 3596.564,
        "transcript": "Akqutii tamaa-i clean up-aaryaram.",
        "translation": "That is the promise of cleaning up."
    },
    "444": {
        "startTime": 3596.579,
        "endTime": 3599.959,
        "transcript": "Anirtima ellangellemni avani",
        "translation": "It's no wonder that in my earliest memories back then"
    },
    "445": {
        "startTime": 3599.964,
        "endTime": 3609.894,
        "transcript": "Arnassagarnek angukara'urlurnek-llu tangaatuunga ciisquteng ayaperluki piyuanaurtut, nengesciiganateng.",
        "translation": "I saw old women and old men walking by supporting themselves on their knees, unable to stretch out [to full height]."
    },
    "446": {
        "startTime": 3609.904,
        "endTime": 3616.584,
        "transcript": "Angukara'urluurtem arnassagaurtellrata-llu ugaani tuaten pivkarluki.",
        "translation": "They were such old men and old women that they did that."
    },
    "447": {
        "startTime": 3617.379,
        "endTime": 3625.989,
        "transcript": "Cunawa maa-i au͡gkut ciuliat arnaunge'rmeng nunaseng clean up-aarturatuamegteggu",
        "translation": "It turned out that because our ancestors, even women, would clean up their village"
    },
    "448": {
        "startTime": 3625.999,
        "endTime": 3634.389,
        "transcript": "Akaarnun yuuqatullinilriit, ciisquteng-ll' ayaperluki tarricaurrluteng.",
        "translation": "They would live a long time, and start walking by supporting themselves with their knees."
    },
    "449": {
        "startTime": 3634.399,
        "endTime": 3640.069,
        "transcript": "Tamaa-i clean up-aalriim akiliutii.",
        "translation": "That's the reward for one who cleans up."
    },
    "450": {
        "startTime": 3640.079,
        "endTime": 3643.899,
        "transcript": "Tuamta-llu qanengssagnek waten qanernaurtut:",
        "translation": "Then they would tell these stories:"
    },
    "451": {
        "startTime": 3643.904,
        "endTime": 3654.084,
        "transcript": "Una-gguq nukalpiaq ilamitun ayuqevkenani, enuqlilluni. Aterluni-llu Picuilngurmek.",
        "translation": "They say this man in his prime was not like his peers, lacking. And his name was Picuilnguq [Bad Hunter]."
    },
    "452": {
        "startTime": 3654.509,
        "endTime": 3658.029,
        "transcript": "Pitengnaq'nge'rmi-ll' pitesciiganani.",
        "translation": "And though he hunted, he couldn't catch anything."
    },
    "453": {
        "startTime": 3658.034,
        "endTime": 3664.004,
        "transcript": "Tamakut-gguq-am ilait ayariluteng makunek piculrianek",
        "translation": "They say that some of those who desire to be like these good hunters"
    },
    "454": {
        "startTime": 3664.014,
        "endTime": 3670.974,
        "transcript": "Nunani clean up-aarteńgurtelartut kia ellimenrilengraateng.",
        "translation": "They start cleaning up their villages though no one tells them to."
    },
    "455": {
        "startTime": 3671.579,
        "endTime": 3679.449,
        "transcript": "Kasngukluku picuitellerteng tamakuni nunani clean up-aarteńgurtelallinilriit.",
        "translation": "Being ashamed of being bad hunters, they start cleaning up those villages."
    },
    "456": {
        "startTime": 3680.549,
        "endTime": 3686.159,
        "transcript": "Tuaten piameng, tamana atu'urqamegteggu",
        "translation": "When they do that, when they practice that"
    },
    "457": {
        "startTime": 3686.169,
        "endTime": 3698.889,
        "transcript": "Imkut nukalpianek piculinek-llu atellget amatairluki picunrurtaqluni tauna tuaten ayuqellria clean up-aarteńgurtaqami.",
        "translation": "One who does that becomes a better hunter than those who are called great hunters, and those who catch a lot, when he cleans up."
    },
    "458": {
        "startTime": 3698.901,
        "endTime": 3714.388,
        "transcript": "Waniwaulliniuq: Agayutem nunani, elliin pini carriucia taumun yugmun quyam ugaan piyullrinek akililallinia, akingutekluku.",
        "translation": "This is what it is: since God is thankful for that person who cleans up his land, he rewards him with what he wants, and he receives that reward."
    },
    "459": {
        "startTime": 3714.388,
        "endTime": 3721.388,
        "transcript": "Unguvaan taktaciatun tuaten ayuqevkararkauluku, enuqlitevkenaku yuuluku.",
        "translation": "He will make him like that for the length of his life, living without being in need."
    },
    "460": {
        "startTime": 3721.395,
        "endTime": 3725.333,
        "transcript": "Clean up-aarturalleq man'a akituqa[piaralliniuq].",
        "translation": "Cleaning up brings great rewards."
    }
};